/*
 * Lashthing "Kies je look" configurator.
 * Vanilla custom element. Contract: docs/CONTRACT.md (repo lash-configurator).
 * Server rendert de complete markup; dit script muteert alleen state, tekst en afbeeldingen.
 */
(function () {
  'use strict';
  if (customElements.get('lash-configurator')) return;

  var ADDED_MS = 1800;
  var LIVE_DEBOUNCE_MS = 400;
  var URL_DEBOUNCE_MS = 300;
  var CART_OPEN_DELAY_MS = 700;

  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  function stripQuery(url) {
    return String(url || '').split('?')[0];
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var LOOP_SEL = 'video[data-circle-video], video[data-howto-video], video[data-loop-src]';
  var MAX_LOOPS_PLAYING = 4;
  var TP_SCRIPT = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

  class LashConfigurator extends HTMLElement {}

  var proto = LashConfigurator.prototype;

  proto.connectedCallback = function () {
    var cfgEl = this.querySelector('[data-lash-config]');
    if (!cfgEl) return;
    try {
      this.cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    // landingspagina (variant B): eigen, kortere strings (bijschrift, story, voorraadregel) over de basisstrings heen
    if (this.cfg.layout === 'landing' && this.cfg.stringsLanding && this.cfg.strings) {
      for (var sk in this.cfg.stringsLanding) {
        if (Object.prototype.hasOwnProperty.call(this.cfg.stringsLanding, sk)) this.cfg.strings[sk] = this.cfg.stringsLanding[sk];
      }
    }
    this.styles = this.cfg.styles || [];
    this.styleMap = {};
    for (var i = 0; i < this.styles.length; i++) this.styleMap[this.styles[i].key] = this.styles[i];
    if (!this.styles.length) return;

    this.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.imgCache = {};
    this.ac = new AbortController();
    this.state = { style: null, length: null, length2: null, prevStyle: null, compare: false, set: 'single', slots: null, activeSlot: 0 };
    this.liveTimer = null;
    this.urlTimer = null;
    this.addedTimer = null;

    var initial = this.initialSelection();
    this.state.style = initial.style;
    this.state.length = initial.length;
    this.state.prevStyle = this.neighbourStyle(initial.style);

    this.bind();
    var perEl = this.querySelector('.lc__price-per');
    this.perSingleText = perEl ? perEl.textContent : '';
    // R2F: de standaardkeuze uit Liquid (data-set = defaultSet) vóórdat de state hem overschrijft
    var liquidSet = this.dataset.set || (this.cfg.defaultSet || 'single');
    // data-set volgt altijd de werkelijke stand: zonder bundel en zonder starter in de config mag er geen 'starter'/'bundle' blijven staan
    this.dataset.set = this.state.set;
    this.render(true);
    // R2D: ?set=bundle preselecteert de 3 + 2-set (alleen als de bundel in de config bestaat)
    try {
      // R2F: standaardkeuze (defaultSet uit Liquid) of ?set= in de URL (Klaviyo/ads); alleen bestaande standen
      var wantSet = new URLSearchParams(window.location.search).get('set') || liquidSet || 'single';
      if (this.cfg.picker && this.cfg.bundle) { this.picks = []; this.pickerTarget = null; this.setSet('bundle', true); }
      else if (wantSet === 'bundle' && this.cfg.bundle) this.setSet('bundle', true);
      else if (wantSet === 'starter' && this.cfg.starter) this.setSet('starter', true);
      else if (this.kitByKey(wantSet)) this.setSet(wantSet, true);
      else if (wantSet === 'single' && (this.cfg.starter || this.cfg.bundle || this.kits().length)) this.setSet('single', true);
    } catch (e) {}
    if (this.cfg.picker) this.setupPicker();
    if (initial.fallbackFrom) {
      this.announce(fill(this.cfg.strings.liveFallback, {
        style: initial.fallbackFrom.title, mm: initial.fallbackFrom.mm,
        style2: this.currentStyle().title, mm2: this.state.length
      }));
    }
    this.setupSticky();
    this.setupWarmup();
    this.setupTrust();
    this.setupLoopVideos();
    this.setupHowto();
    this.setupStory();
    this.setupStyleHelp();
    this.setupTrustpilot();
    this.beacon('cfg_view', { mode: this.cfg.mode });
  };

  proto.disconnectedCallback = function () {
    if (this.ac) this.ac.abort();
    if (this.ioAtc) this.ioAtc.disconnect();
    if (this.ioSection) this.ioSection.disconnect();
    if (this.moCart) this.moCart.disconnect();
    clearTimeout(this.liveTimer);
    clearTimeout(this.urlTimer);
    clearTimeout(this.addedTimer);
    clearInterval(this.trustTimer);
    if (this.ioLoops) this.ioLoops.disconnect();
    if (this.storyOpen) this.closeStory();
  };

  /* ---------- selectie ---------- */

  proto.lengthOf = function (style, mm) {
    if (!style) return null;
    for (var i = 0; i < style.lengths.length; i++) {
      if (String(style.lengths[i].mm) === String(mm)) return style.lengths[i];
    }
    return null;
  };

  proto.currentStyle = function () {
    return this.styleMap[this.state.style];
  };

  proto.current = function () {
    return this.lengthOf(this.currentStyle(), this.state.length) || {};
  };

  proto.neighbourStyle = function (key) {
    var idx = -1;
    for (var i = 0; i < this.styles.length; i++) if (this.styles[i].key === key) idx = i;
    if (idx < 0) return this.styles[0].key;
    var next = this.styles[idx + 1] || this.styles[idx - 1] || this.styles[idx];
    return next.key;
  };

  proto.initialSelection = function () {
    var cfg = this.cfg;
    var sel = cfg.selected || {};
    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('variant');
    // 1. deeplink ?variant= (blijft staan, ook als uitverkocht)
    if (urlVariant) {
      for (var i = 0; i < this.styles.length; i++) {
        for (var j = 0; j < this.styles[i].lengths.length; j++) {
          if (String(this.styles[i].lengths[j].variantId) === String(urlVariant)) {
            return { style: this.styles[i].key, length: String(this.styles[i].lengths[j].mm) };
          }
        }
      }
    }
    // 2. server-side geselecteerd (defaults) — met deterministische fallback bij onbeschikbaarheid
    var styleKey = this.styleMap[sel.style] ? sel.style : this.styles[0].key;
    var mm = sel.length || cfg.defaults.length || cfg.lengthOrder[0];
    var wanted = this.lengthOf(this.styleMap[styleKey], mm);
    if (wanted && wanted.available) return { style: styleKey, length: String(mm) };
    var fallback = this.findFallback(styleKey, mm);
    if (fallback) {
      return {
        style: fallback.style, length: fallback.length,
        fallbackFrom: { title: this.styleMap[styleKey].title, mm: mm }
      };
    }
    return { style: styleKey, length: String(mm) };
  };

  proto.lengthPreference = function (mm) {
    var order = (this.cfg.lengthOrder || []).map(String);
    var pref = [];
    if (order.indexOf(String(mm)) >= 0) pref.push(String(mm));
    var rest = order.filter(function (x) { return pref.indexOf(x) < 0; });
    rest.sort(function (a, b) { return Number(a) - Number(b); });
    return pref.concat(rest);
  };

  proto.findFallback = function (styleKey, mm) {
    var startIdx = 0;
    for (var i = 0; i < this.styles.length; i++) if (this.styles[i].key === styleKey) startIdx = i;
    var pref = this.lengthPreference(mm);
    for (var step = 0; step < this.styles.length; step++) {
      var style = this.styles[(startIdx + step) % this.styles.length];
      for (var p = 0; p < pref.length; p++) {
        var len = this.lengthOf(style, pref[p]);
        if (len && len.available) return { style: style.key, length: pref[p] };
      }
    }
    return null;
  };

  /* ---------- events ---------- */

  proto.bind = function () {
    var self = this;
    var opts = { signal: this.ac.signal };

    this.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.hasAttribute('data-style')) self.set({ style: t.value }, 'style');
      else if (t.hasAttribute('data-length')) self.set({ length: t.value }, 'length');
      else if (t.hasAttribute('data-length2')) { self.state.length2 = t.value; self.render(false); }
      else if (t.hasAttribute('data-set')) self.setSet(t.value, false);
    }, opts);

    this.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-atc]');
      if (atc && self.contains(atc)) {
        e.preventDefault();
        self.addToCart(atc);
        // 17-09: vanuit de schermvullende video sluiten we hem, anders valt de winkelwagen erachter
        if (atc.hasAttribute('data-atc-story')) self.closeStory();
        return;
      }
      var cmp = e.target.closest('[data-compare-toggle]');
      if (cmp && self.contains(cmp)) { e.preventDefault(); self.toggleCompare(); return; }
      // landingspagina (variant B): galerij-thumbs en pijlen selecteren een stijl, tabs wisselen het uitleg-paneel,
      // de video-facade laadt de YouTube-iframe pas na een klik (geen third-party requests bij het laden)
      // 16-09 (opdracht Thomas): een thumb is een galerij-knop. Hij toont die foto groot en laat de
      // gekozen stijl met rust; de stijl kies je in stap 2.
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb && self.contains(thumb)) { e.preventDefault(); self.pickGallery(Number(thumb.getAttribute('data-gallery-thumb')) || 0); return; }
      // 18-09 (melding Thomas): de pijlen naast de grote foto sprongen naar de volgende STIJL en
      // zetten daarmee de galerij terug op de close-up van die stijl. Wie op foto 5 stond ging dus
      // 'terug'. De pijlen lopen nu door dezelfde galerij als de duimnagels; de stijl kies je in stap 2.
      var gstep = e.target.closest('[data-gallery-step]');
      if (gstep && self.contains(gstep)) { e.preventDefault(); self.stepGallery(parseInt(gstep.getAttribute('data-gallery-step'), 10) || 1); return; }
      var step = e.target.closest('[data-style-step]');
      if (step && self.contains(step)) { e.preventDefault(); self.stepStyle(parseInt(step.getAttribute('data-style-step'), 10) || 1); return; }
      var tab = e.target.closest('[data-tab]');
      if (tab && self.contains(tab)) { e.preventDefault(); self.switchTab(tab.getAttribute('data-tab'), true); return; }
      var play = e.target.closest('[data-video-play]');
      if (play && self.contains(play)) { e.preventDefault(); self.playVideo(play.closest('[data-video-facade]')); return; }
      // R2A: story-speler (bolletjes), pauzeknop van de uitleg-clips
      var so = e.target.closest('[data-story-open]');
      if (so && self.contains(so)) { e.preventDefault(); self.openStory(so.getAttribute('data-story-open'), so); return; }
      var sg = e.target.closest('[data-story-go]');
      if (sg && self.contains(sg)) { e.preventDefault(); self.loadStory(sg.getAttribute('data-story-go')); return; }
      var sm = e.target.closest('[data-story-mute]');
      if (sm && self.contains(sm)) { e.preventDefault(); self.toggleStoryMute(); return; }
      var stp = e.target.closest('[data-story-tap]');
      if (stp && self.contains(stp)) { e.preventDefault(); self.storyMuted = false; self.applyStoryMute(); self.showStoryTap(false); return; }
      var sc = e.target.closest('[data-story-close]');
      if (sc && self.contains(sc)) { e.preventDefault(); self.closeStory(); return; }
      var hsd = e.target.closest('[data-howto-sound]');
      if (hsd && self.contains(hsd)) { e.preventDefault(); self.toggleHowtoSound(hsd); return; }
      var ht = e.target.closest('[data-howto-toggle]');
      if (ht && self.contains(ht)) { e.preventDefault(); self.toggleHowto(ht); return; }
      var slot = e.target.closest('[data-slot]');
      if (slot && self.contains(slot)) { e.preventDefault(); self.setActiveSlot(parseInt(slot.getAttribute('data-slot'), 10) - 1); }
    }, opts);

    // R2A story-speler: Escape sluit, Tab blijft in de dialog (focus-trap)
    document.addEventListener('keydown', function (e) {
      if (!self.storyOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closeStory(); return; }
      if (e.key !== 'Tab' || !self.storyRoot) return;
      var f = Array.prototype.filter.call(self.storyRoot.querySelectorAll('button, input, [tabindex="0"]'), function (el) {
        return !el.hidden && !el.closest('[hidden]') && el.getBoundingClientRect().width > 0;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !self.storyRoot.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !self.storyRoot.contains(a))) { e.preventDefault(); first.focus(); }
    }, opts);

    this.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-tab]');
      if (!tab || !self.contains(tab)) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') return;
      var tabs = Array.prototype.slice.call(self.querySelectorAll('[data-tab]'));
      var idx = tabs.indexOf(tab);
      if (idx < 0) return;
      var next = e.key === 'ArrowLeft' ? idx - 1 : e.key === 'ArrowRight' ? idx + 1 : e.key === 'Home' ? 0 : tabs.length - 1;
      next = (next + tabs.length) % tabs.length;
      e.preventDefault();
      self.switchTab(tabs[next].getAttribute('data-tab'), true);
    }, opts);

    this.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.state.compare) {
        var cmp = self.querySelector('[data-compare-toggle]');
        if (cmp && document.activeElement === cmp) self.toggleCompare();
      }
    }, opts);

    document.addEventListener('shopify:block:select', function (e) {
      if (!e.detail || !self.contains(e.target)) return;
      var blockId = e.detail.blockId;
      for (var i = 0; i < self.styles.length; i++) {
        if (self.styles[i].blockId && self.styles[i].blockId === blockId) self.set({ style: self.styles[i].key }, 'editor');
      }
    }, opts);
  };

  // De duimnagel die bij een stijl hoort: 0 is de kitfoto, daarna komen de stijlen in volgorde.
  proto.thumbVoorStijl = function (key) {
    var lijst = this.styles || [];
    for (var i = 0; i < lijst.length; i++) if (lijst[i].key === key) return i + 1;
    return this.galleryIndex || 0;
  };

  proto.set = function (patch, source) {
    if (patch.style && patch.style !== this.state.style) {
      this.state.prevStyle = this.state.style;
      this.state.style = patch.style;
      // 16-09 (opdracht Thomas): een stijl kiezen brengt je naar de close-up van dat oog.
      // Andersom niet: op een foto drukken laat de stijl staan. render() hieronder pakt de
      // nieuwe index op, dus de grote foto en de actieve duimnagel lopen mee.
      this.galleryIndex = this.thumbVoorStijl(patch.style);
    }
    if (patch.length) this.state.length = String(patch.length);
    if (this.state.set === 'bundle' && this.state.slots) {
      this.state.slots[this.state.activeSlot] = { style: this.state.style, length: this.state.length };
    }
    this.bundleSoldOut = false; // een nieuwe keuze mag opnieuw geprobeerd worden
    this.render(false);
    this.syncUrl();
    var v = this.current();
    var style = this.currentStyle();
    var liveMsg = fill(this.cfg.strings.live, { style: style.title, mm: this.state.length });
    if (this.state.set === 'bundle' && this.state.slots) liveMsg += ' ' + fill(this.cfg.strings.slotActive || 'Strip {n}', { n: this.state.activeSlot + 1 }) + '.';
    this.announce(liveMsg);
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'lash_configurator_select',
        lc_style: style.key, lc_length: this.state.length, lc_variant_id: v.variantId || null, lc_source: source
      });
    }
    this.beacon('cfg_' + source, { style: style.key, length: this.state.length });
  };

  /* ---------- render ---------- */

  // 17-09: werkt nu op ELK element met deze haak, niet alleen het eerste. De koopbalk in de video
  // gebruikt dezelfde haken als het koopvak ([data-summary], [data-atc-price]); met querySelector
  // bleef die leeg omdat het koopvak vooraan in de DOM staat.
  proto.text = function (sel, value) {
    var els = this.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== value) els[i].textContent = value;
    }
  };

  proto.render = function (first) {
    var style = this.currentStyle();
    var v = this.current();
    var s = this.cfg.strings;
    var available = !!v.available;

    this.dataset.style = style.key;
    this.dataset.length = this.state.length;
    this.dataset.variantId = v.variantId ? String(v.variantId) : '';
    this.dataset.available = available ? 'true' : 'false';

    var styleRadio = this.querySelector('input[data-style][value="' + style.key + '"]');
    if (styleRadio && !styleRadio.checked) styleRadio.checked = true;
    var lengthRadio = this.querySelector('input[data-length][value="' + this.state.length + '"]');
    if (lengthRadio && !lengthRadio.checked) lengthRadio.checked = true;

    this.renderPills(style);

    var summary = style.title + ' · ' + this.state.length + ' mm';
    this.text('[data-summary]', summary);
    // 17-09: de koopbalk in de video noemt ook de kit, want dat is wat er toegevoegd wordt.
    // Twee strips van dezelfde lengte lezen als '12 + 12 mm', net als in de balk onderaan.
    var storySum = summary;
    var storyKit = this.kitByKey ? this.kitByKey(this.state.set) : null;
    if (storyKit && storyKit.label) {
      var mm = this.state.length;
      var aantal = this.kitStrips ? this.kitStrips(storyKit).length : 0;
      if (aantal > 1) {
        var stukken = [];
        for (var sm = 0; sm < aantal; sm++) stukken.push(mm);
        mm = stukken.join(' + ');
      }
      storySum = storyKit.label + ' \u00b7 ' + style.title + ' \u00b7 ' + mm + ' mm';
    }
    this.text('[data-story-sum]', storySum);
    this.text('[data-sticky-summary]', summary);
    this.text('[data-price]', v.priceFormatted || '');
    this.text('[data-price-intro]', v.priceFormatted || '');
    this.text('[data-atc-price]', v.priceFormatted || '');
    this.text('[data-sticky-price]', v.priceFormatted || '');
    this.renderThumbs();
    this.text('[data-caption]', this.galleryCaption(style, v));
    this.text('[data-descriptor]', style.descriptor ? style.descriptor + '.' : '');

    var details = this.querySelector('[data-details]');
    if (details) {
      var base = '/products/' + style.handle;
      details.setAttribute('href', v.originalVariantId ? base + '?variant=' + v.originalVariantId : base);
    }

    var stickyThumb = this.querySelector('[data-sticky-thumb]');
    if (stickyThumb && style.thumb && stickyThumb.getAttribute('src') !== style.thumb.src) stickyThumb.src = style.thumb.src;

    this.setAtcAvailability(available, style);
    this.updateKlarna();
    this.renderScarcity(v);
    this.renderBundle(style, v);
    // R2G: in de picker-flow is de hoofd-ATC de losse link; de root-state volgt dan de gekozen losse variant (contract: origineel
    // niet beschikbaar => data-state=soldout), niet de 5 slots van de oude set-keuze (die maakten de state na markSoldOut weer 'idle')
    if (this.state.set === 'bundle' && this.cfg.bundle && !this.cfg.picker) { var bt = this.bundleTotals(); available = !!(bt && bt.ok); }
    this.renderStarter(style, v);
    this.renderKits(style, v);
    this.renderPlan();
    if (this.state.set === 'starter' && this.cfg.starter) { available = available && !!(this.cfg.starter.toolkit && this.cfg.starter.toolkit.available) && !this.starterSoldOut; if (!available) this.setAtcAvailability(false, style); }
    this.renderAtcCompare();
    if (!first) this.swapImage(this.galleryImage(style, v));
    else this.preload(this.imageFor(style, v));
    if (this.state.compare) this.renderCompare();
    if (this.cfg.mode !== 'prelaunch' && this.dataset.state !== 'busy') this.setState(available ? 'idle' : 'soldout');
  };

  proto.renderPills = function (style) {
    var s = this.cfg.strings;
    var inputs = this.querySelectorAll('input[data-length]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var len = this.lengthOf(style, input.value);
      var ok = this.state.set === 'bundle' ? !!(len && len.insiderAvailable) : !!(len && len.available);
      // CONTRACT: onbeschikbare lengte = radio `disabled` (niet kiesbaar) + pill-state "Uitverkocht";
      // een gedeeplinkte uitverkochte selectie blijft checked én disabled (CTA toont "Uitverkocht").
      input.disabled = !ok;
      if (ok) {
        input.removeAttribute('data-unavailable');
      } else {
        input.setAttribute('data-unavailable', 'true');
      }
      var label = this.querySelector('label[data-length-label="' + input.value + '"]');
      if (label) {
        label.classList.toggle('is-unavailable', !ok);
        var st = label.querySelector('[data-pill-state]');
        if (st) st.textContent = ok ? '' : s.soldOut;
      }
    }
  };

  /* Klarna on-site messaging: sommige placements tonen pas een bedrag als data-purchase_amount is meegegeven, in
     centen. Het bedrag komt uit dezelfde knop als die de klant ziet, zodat er nooit een ander bedrag in de
     Klarna-melding staat dan in het koopvak. Let op: render() zet eerst de losse stripprijs en pas daarna de
     kitprijs, dus dit moet NA de render gebeuren; vandaar de setTimeout 0. Zonder placement doet dit niets. */
  proto.updateKlarna = function () {
    if (!this.querySelector('[data-klarna-osm]')) return;
    this.watchKlarna();
    if (this.klarnaTimer) return;
    var self = this;
    this.klarnaTimer = window.setTimeout(function () {
      self.klarnaTimer = null;
      self.applyKlarnaAmount();
    }, 0);
  };

  proto.applyKlarnaAmount = function () {
    var el = this.querySelector('[data-klarna-osm]');
    if (!el) return;
    var bron = this.querySelector('[data-atc]:not([data-atc-sticky]):not([data-atc-quiz]) [data-atc-price]');
    var cijfers = (bron && !bron.hidden ? (bron.textContent || '') : '').replace(/[^0-9]/g, '');
    if (!cijfers) return;
    var centen = parseInt(cijfers, 10);
    if (!centen) return;
    if (el.getAttribute('data-purchase_amount') !== String(centen)) el.setAttribute('data-purchase_amount', String(centen));
  };

  /* Pas omwisselen als Klarna echt iets getekend heeft. Zo niet, dan blijft de eigen badge gewoon staan: een fout
     client-id, een geblokkeerde SDK of een storing bij Klarna mag nooit een leeg gat in het koopvak opleveren. */
  proto.watchKlarna = function () {
    if (this.klarnaWatch) return;
    this.klarnaWatch = true;
    var self = this;
    var wrap = this.querySelector('[data-klarna-wrap]');
    var el = this.querySelector('[data-klarna-osm]');
    var eigen = this.querySelector('[data-klarna]');
    if (!wrap || !el) return;
    var pogingen = 0;
    var tik = function () {
      pogingen += 1;
      var getekend = el.shadowRoot ? !!el.shadowRoot.firstElementChild : el.offsetHeight > 0;
      if (getekend) {
        wrap.hidden = false;
        if (eigen) eigen.hidden = true;
        return;
      }
      if (pogingen < 12) window.setTimeout(tik, 500); // ruim 6 seconden geduld, daarna blijft de eigen badge staan
    };
    window.setTimeout(tik, 400);
  };

  // galerij-thumbs (variant B): precies één thumb aria-pressed=true; de actieve thumb in beeld schuiven op mobiel
  // 16-09: de actieve thumb volgt de galerij, niet de stijl.
  proto.renderThumbs = function () {
    var thumbs = this.querySelectorAll('[data-gallery-thumb]');
    var idx = this.galleryIndex || 0;
    for (var i = 0; i < thumbs.length; i++) {
      var on = Number(thumbs[i].getAttribute('data-gallery-thumb')) === idx;
      thumbs[i].classList.toggle('is-active', on);
      thumbs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var kitImg = this.querySelector('[data-gallery-kit-img]');
    var kit = this.kitByKey ? this.kitByKey(this.state.set) : null;
    if (kitImg && kit && kit.hero && kit.hero.src && kitImg.getAttribute('src') !== kit.hero.src) {
      kitImg.src = kit.hero.src;
      if (kit.hero.srcset) kitImg.srcset = kit.hero.srcset;
    }
  };

  // De foto die groot hoort te staan: index 0 is de kitfoto, 1 en verder zijn de close-ups.
  proto.galleryImage = function (style, v) {
    var idx = this.galleryIndex || 0;
    if (idx > 0) {
      var t = this.querySelector('[data-gallery-thumb="' + idx + '"]');
      if (t && t.getAttribute('data-gallery-src')) {
        return { src: t.getAttribute('data-gallery-src'), srcset: t.getAttribute('data-gallery-srcset') || '', alt: t.getAttribute('data-gallery-alt') || '' };
      }
    }
    return this.imageFor(style, v);
  };

  // Het bijschrift hoort bij de foto die je ziet, niet bij de stijl die je gekozen hebt.
  // Thumb 1 tot en met het aantal stijlen zijn close-ups; wat daarna komt zijn extra foto's
  // die voor elke stijl en kit gelden en hun eigen omschrijving hebben.
  proto.galleryCaption = function (style, v) {
    var idx = this.galleryIndex || 0;
    if (idx > 0) {
      var eigen = this.styles && this.styles[idx - 1];
      if (eigen) return this.captionFor(eigen, {});
      var t = this.querySelector('[data-gallery-thumb="' + idx + '"]');
      if (t) return t.getAttribute('data-gallery-alt') || '';
    }
    // Foto 1 is de overzichtsfoto van de kit. Daar hoort te staan wat erin zit, geen close-up.
    var kit = this.kitByKey ? this.kitByKey(this.state.set) : null;
    if (kit && kit.hero && kit.hero.src) {
      var delen = [];
      var aantal = this.kitStrips ? this.kitStrips(kit).length : (kit.strips || 0);
      if (aantal) delen.push(aantal + 'x lash strip' + (aantal === 1 ? '' : 's'));
      for (var e = 0; e < (kit.extras || []).length; e++) {
        var et = kit.extras[e].title || '';
        delen.push('1x ' + (et.split(' - ')[0].split(' | ')[0] || et).trim());
      }
      if (delen.length) return kit.label + ': ' + delen.join(', ');
    }
    return this.captionFor(style, v);
  };

  proto.pickGallery = function (idx) {
    this.galleryIndex = idx;
    this.renderThumbs();
    var style = this.currentStyle();
    var v = this.current();
    this.swapImage(this.galleryImage(style, v));
    this.text('[data-caption]', this.galleryCaption(style, v));
  };

  proto.stepGallery = function (delta) {
    var thumbs = this.querySelectorAll('[data-gallery-thumb]');
    var n = thumbs.length;
    if (!n) return;
    var idx = this.galleryIndex || 0;
    this.pickGallery((idx + delta + n) % n);
  };

  proto.stepStyle = function (delta) {
    var idx = -1;
    for (var i = 0; i < this.styles.length; i++) if (this.styles[i].key === this.state.style) idx = i;
    var next = this.styles[(idx + delta + this.styles.length) % this.styles.length];
    if (next) this.set({ style: next.key }, 'arrow');
  };

  proto.switchTab = function (name, focus) {
    var tabs = this.querySelectorAll('[data-tab]');
    var panels = this.querySelectorAll('[data-panel]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-tab') === name;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', on ? '0' : '-1');
      tabs[i].classList.toggle('is-active', on);
      if (on && focus) { try { tabs[i].focus({ preventScroll: true }); } catch (e) {} }
    }
    for (var j = 0; j < panels.length; j++) panels[j].hidden = panels[j].getAttribute('data-panel') !== name;
  };

  proto.playVideo = function (box) {
    if (!box || box.querySelector('iframe')) return;
    var src = box.getAttribute('data-video-src');
    if (!src) return;
    var iframe = document.createElement('iframe');
    iframe.className = 'lc__video-frame';
    iframe.src = src;
    iframe.title = box.getAttribute('data-video-title') || 'Video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    var btn = box.querySelector('[data-video-play]');
    if (btn) btn.remove();
    box.classList.add('is-playing');
    box.appendChild(iframe);
  };

  // trust-strip (variant B, mobiel): één item per keer, elke 3,5 s de volgende; bij reduced motion of desktop staan alle drie
  proto.setupTrust = function () {
    var self = this;
    var strip = this.querySelector('[data-trust]');
    if (!strip || this.reduced) return;
    var items = strip.querySelectorAll('.lc__trust-item');
    if (items.length < 2) return;
    var idx = 0;
    this.trustTimer = setInterval(function () {
      if (window.innerWidth >= 750) return;
      idx = (idx + 1) % items.length;
      for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-active', i === idx);
    }, 3500);
  };

  // R2A video-laadcontract (docs/CONTRACT.md): een loopvideo (bolletje, uitleg-clip) krijgt pas videodata zodra zijn element
  // voor het eerst de IntersectionObserver-drempel (0,25) bereikt; buiten beeld pauzeren; een gebruikers-pauze wordt
  // gerespecteerd; saveData/reduced motion → alleen poster; maximaal 4 tegelijk spelend (oudste pauzeren).
  proto.setupLoopVideos = function () {
    var self = this;
    var vids = this.querySelectorAll(LOOP_SEL);
    this.loopPlaying = [];
    if (!vids.length) return;
    var c = navigator.connection;
    if (this.reduced || (c && c.saveData) || !('IntersectionObserver' in window)) return;
    this.ioLoops = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        v.dataset.inView = entries[i].isIntersecting ? '1' : '';
        if (entries[i].isIntersecting) self.playLoop(v);
        else if (!v.paused) v.pause();
      }
    }, { threshold: 0.25 });
    for (var j = 0; j < vids.length; j++) this.ioLoops.observe(vids[j]);
  };

  proto.loopSrc = function (v) {
    return v.getAttribute('data-circle-video') || v.getAttribute('data-howto-video') || v.getAttribute('data-loop-src') || '';
  };

  proto.playLoop = function (v) {
    if (!v || v.dataset.userPaused === '1' || this.storyOpen) return;
    if (!v.getAttribute('src')) {
      v.muted = true;
      v.setAttribute('src', this.loopSrc(v));
      try { v.load(); } catch (e) {}
    }
    var list = (this.loopPlaying || []).filter(function (x) { return x !== v && !x.paused; });
    while (list.length >= MAX_LOOPS_PLAYING) list.shift().pause();
    list.push(v);
    this.loopPlaying = list;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };

  // uitleg-clips (tabs): pauze/afspeel-knop (WCAG 2.2.2); aria-pressed=true = door de gebruiker gepauzeerd
  proto.setupHowto = function () {
    var btns = this.querySelectorAll('[data-howto-toggle]');
    var s = this.cfg.strings;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-label', s.howtoPause || 'Pauze');
      btns[i].setAttribute('aria-pressed', 'false');
    }
  };

  // 17-09 (melding Thomas): de uitleg-clips speelden zonder geluid en er was geen knop om het
  // aan te zetten. Gedempt starten moet blijven, anders blokkeert de browser het afspelen;
  // deze knop zet het geluid aan na een tik van de klant.
  proto.toggleHowtoSound = function (knop) {
    var media = knop.closest('.lc__howto-media');
    var v = media && media.querySelector('video[data-howto-video]');
    if (!v) return;
    if (!v.getAttribute('src') && !v.querySelector('source')) { v.setAttribute('src', v.getAttribute('data-howto-video')); v.load(); }
    v.muted = !v.muted;
    knop.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
    knop.setAttribute('aria-label', v.muted ? 'Geluid aanzetten' : 'Geluid uitzetten');
    if (!v.muted) { v.volume = 1; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  };

  proto.toggleHowto = function (btn) {
    var media = btn.closest('.lc__howto-media');
    var v = media && media.querySelector('video[data-howto-video]');
    if (!v) return;
    var s = this.cfg.strings;
    if (v.paused) {
      v.dataset.userPaused = '';
      if (!v.getAttribute('src')) { v.muted = true; v.setAttribute('src', this.loopSrc(v)); try { v.load(); } catch (e) {} }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', s.howtoPause || 'Pauze');
    } else {
      v.pause();
      v.dataset.userPaused = '1';
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', s.howtoPlay || 'Afspelen');
    }
  };

  /* ---------- R2A: story-speler (bolletjes) ---------- */

  /* ---------- Stijlquiz (14-09-2026, opdracht Thomas; verving het tabbladvenster) ----------
     Twee of drie korte vragen die eindigen op een aanbeveling met een echte add-to-cart. De antwoorden worden
     opgebouwd uit wat de pagina al heeft: de categorieen en de lengtes uit de stijlblokken en de set-keuzes uit
     het koopvak. Er staat dus nergens een tweede lijst met stijlen of maten die uit de pas kan gaan lopen. */
  proto.setupStyleHelp = function () {
    var self = this;
    var box = this.querySelector('[data-help]');
    if (!box) return;
    var conf = box.querySelector('[data-quiz-config]');
    this.quizStrings = {};
    if (conf) { try { this.quizStrings = JSON.parse(conf.textContent) || {}; } catch (e) { this.quizStrings = {}; } }
    this.quizAnswers = {};
    this.quizAt = 0;
    var opts = { signal: this.ac.signal };
    this.addEventListener('click', function (e) {
      if (e.target.closest('[data-help-open]')) { e.preventDefault(); self.openHelp(e.target.closest('[data-help-open]')); return; }
      if (e.target.closest('[data-help-close]')) { e.preventDefault(); self.closeHelp(); return; }
      if (e.target.closest('[data-lenhelp-open]')) { e.preventDefault(); self.openLenHelp(e.target.closest('[data-lenhelp-open]')); return; }
      if (e.target.closest('[data-lenhelp-close]')) { e.preventDefault(); self.closeLenHelp(); return; }
      var pick = e.target.closest('[data-quiz-pick]');
      if (pick && self.contains(pick)) { e.preventDefault(); self.quizAnswer(pick.getAttribute('data-quiz-pick'), pick.getAttribute('data-quiz-value')); return; }
      if (e.target.closest('[data-quiz-back]')) { e.preventDefault(); self.quizAt = Math.max(0, self.quizAt - 1); self.quizRender(); return; }
      if (e.target.closest('[data-quiz-restart]')) { e.preventDefault(); self.quizStart(); return; }
      if (e.target.closest('[data-quiz-own]')) { e.preventDefault(); self.closeHelp(); return; }
      // de add-to-cart in de uitkomst is een gewone [data-atc]-knop: die wordt door de bestaande handler afgehandeld,
      // hier sluiten we alleen het venster zodat de winkelwagen zichtbaar wordt. Geen preventDefault.
      var qadd = e.target.closest('[data-atc-quiz]');
      if (qadd && self.contains(qadd) && !qadd.disabled) self.closeHelp();
    }, opts);
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeHelp(); }
    }, opts);
    var lenBox = this.querySelector('[data-lenhelp]');
    if (lenBox) lenBox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeLenHelp(); }
    }, opts);
  };

  /* Lengte-hulpvenster (15-09, opdracht Thomas): dezelfde uitleg als in de quiz, los te openen naast de lengtekeuze. */
  proto.openLenHelp = function (opener) {
    var box = this.querySelector('[data-lenhelp]');
    if (!box) return;
    this.lenHelpOpener = opener || null;
    box.hidden = false;
    box.removeAttribute('inert');
    document.documentElement.classList.add('lc-story-open');
    this.lenHelpOpen = true;
    var bar = this.querySelector('[data-sticky]');
    if (bar) this.updateSticky(bar);
    this.guardChat();
    var first = box.querySelector('[data-lenhelp-body]') || box.querySelector('[data-lenhelp-close]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    this.beacon('cfg_lenhelp_open', {});
  };

  proto.closeLenHelp = function () {
    var box = this.querySelector('[data-lenhelp]');
    if (!box || box.hidden) return;
    box.hidden = true;
    box.setAttribute('inert', '');
    if (!this.helpOpen && !this.storyOpen) document.documentElement.classList.remove('lc-story-open');
    this.lenHelpOpen = false;
    var bar = this.querySelector('[data-sticky]');
    if (bar) this.updateSticky(bar);
    this.guardChat();
    if (this.lenHelpOpener && this.lenHelpOpener.focus) this.lenHelpOpener.focus();
    this.lenHelpOpener = null;
  };

  /* De vragen (15-09-2026, opdracht Thomas; tweede ronde dezelfde dag): de quiz vraagt niet naar look-categorie of
     lengte in mm, maar naar wat iemand kent. Volgorde: (0) al eerder besteld? ja -> welke stijl -> de 3 + 2 actie van
     die stijl (geen tweede kennismaking nodig); nee -> (1) welke look (lash lift / mascara / salonlook, met een
     vervolgvraag waar dat nodig is) -> (2) eigen wimpers (bepaalt de mm, met een oogillustratie per antwoord) ->
     (3) eigen wimpers ook verzorgen? ja -> de set met serum, nee -> de standaardset. De vraagboom staat in de
     sectie-instellingen als regels "tekst | toelichting | doel | beeld". Doel van een look-antwoord: een stijl (key,
     titel of categorie) of "vraag:f1" / "vraag:f2"; doel van een wimper-antwoord: een lengte in mm; beeld: "stijl"
     (de foto van de gekozen stijl) of "foto:<url>". Alles wordt tegen de stijlen, lengtes en sets van deze pagina
     gehouden: een doel dat hier niet bestaat valt weg, een vraag met minder dan twee echte antwoorden ook, en een
     vervolgvraag met precies een antwoord wordt dat antwoord. Zo kan er nooit iets uitkomen dat niet in het koopvak
     staat. */
  proto.quizLines = function (raw) {
    var out = [], parts = String(raw || '').split(/\r?\n|;/), i;
    for (i = 0; i < parts.length; i++) {
      var f = parts[i].split('|'), label = (f[0] || '').trim();
      if (!label) continue;
      out.push({ label: label, sub: (f[1] || '').trim(), to: (f[2] || '').trim().toLowerCase(), media: (f[3] || '').trim() });
    }
    return out;
  };

  // doel -> { follow: 'f1' } | { style: <stijl uit de config> } | null
  proto.quizTarget = function (to) {
    if (!to) return null;
    var m = /^(?:vraag|ask|follow):\s*(\w+)$/.exec(to);
    if (m) return { follow: m[1] };
    var styles = this.styles || [], i;
    for (i = 0; i < styles.length; i++) if (String(styles[i].key).toLowerCase() === to) return { style: styles[i] };
    for (i = 0; i < styles.length; i++) if (String(styles[i].title || '').toLowerCase() === to) return { style: styles[i] };
    for (i = 0; i < styles.length; i++) if (String(styles[i].category || '').toLowerCase() === to) return { style: styles[i] };
    return null;
  };

  // beeld bij een antwoord: "stijl" = de foto van de stijl waar het antwoord op uitkomt, "foto:<url>" = eigen foto
  proto.quizMedia = function (media, style) {
    var m = String(media || '').trim();
    if (!m) return null;
    if (/^(foto|img|image):/i.test(m)) { var u = m.replace(/^(foto|img|image):\s*/i, ''); return u ? { src: u } : null; }
    if (/^https?:\/\//i.test(m) || m.indexOf('//') === 0) return { src: m };
    if ((m === 'stijl' || m === 'style') && style) {
      var src = (style.thumb && (style.thumb.src2x || style.thumb.src)) || (style.preview && style.preview.src) || '';
      // 21-09: de lookfoto staat ingezoomd in de quiz; op 320 px werd dat zichtbaar zacht, dus een ruimere maat
      // opvragen bij dezelfde bron (geen width in de url = laten staan)
      if (src) src = src.replace(/([?&]width=)\d+/, '$1480');
      return src ? { src: src } : null;
    }
    return null;
  };

  // een vervolgvraag: alleen de antwoorden die op een stijl van deze pagina uitkomen
  proto.quizFollow = function (id) {
    var s = this.quizStrings || {};
    var raw = s[id + 'a'];
    if (!raw) return null;
    var lines = this.quizLines(raw), opts = [], i;
    for (i = 0; i < lines.length; i++) {
      var t = this.quizTarget(lines[i].to);
      if (t && t.style) opts.push({ value: t.style.key, label: lines[i].label, sub: lines[i].sub, style: t.style, media: this.quizMedia(lines[i].media, t.style) });
    }
    return { id: id, q: s[id + 'q'] || '', options: opts };
  };

  // vraag 1: elk antwoord komt uit op een stijl of op een vervolgvraag met minstens twee antwoorden
  proto.quizLookOptions = function () {
    var s = this.quizStrings || {};
    var lines = this.quizLines(s.q1a), opts = [], i;
    for (i = 0; i < lines.length; i++) {
      var t = this.quizTarget(lines[i].to);
      if (!t) continue;
      if (t.follow) {
        var f = this.quizFollow(t.follow);
        if (!f || !f.options.length) continue;
        if (f.options.length === 1) opts.push({ value: 'style:' + f.options[0].value, label: lines[i].label, sub: lines[i].sub, style: f.options[0].style, media: this.quizMedia(lines[i].media, f.options[0].style) });
        else opts.push({ value: 'follow:' + t.follow, label: lines[i].label, sub: lines[i].sub, follow: f, media: this.quizMedia(lines[i].media, null) });
      } else {
        opts.push({ value: 'style:' + t.style.key, label: lines[i].label, sub: lines[i].sub, style: t.style, media: this.quizMedia(lines[i].media, t.style) });
      }
    }
    return opts;
  };

  // vraag 2 (eigen wimpers): alleen de lengtes die op deze pagina bestaan, van kort naar lang
  proto.quizMmOptions = function () {
    var s = this.quizStrings || {};
    var styles = this.styles || [], seen = {}, i, j;
    for (i = 0; i < styles.length; i++) for (j = 0; j < styles[i].lengths.length; j++) seen[String(styles[i].lengths[j].mm)] = true;
    var lines = this.quizLines(s.q2a), opts = [];
    for (i = 0; i < lines.length; i++) {
      var mm = String(parseInt(lines[i].to, 10));
      if (!seen[mm]) continue;
      opts.push({ value: mm, label: lines[i].label, sub: lines[i].sub });
    }
    opts.sort(function (x, y) { return Number(x.value) - Number(y.value); });
    return opts;
  };

  // vraag 3 (verzorging): ja = de set met serum, nee = de standaardset; alleen als beide sets in het koopvak staan
  proto.quizCareOptions = function () {
    var s = this.quizStrings || {};
    var careKey = s.careSet || 'deluxe', kitKey = s.kitSet || 'premium';
    var out = [];
    if (careKey === kitKey || !s.careYes || !s.careNo) return out;
    if (!this.querySelector('input[data-set][value="' + careKey + '"]') || !this.querySelector('input[data-set][value="' + kitKey + '"]')) return out;
    // 21-09 (opdracht Thomas): geen setnaam onder de antwoorden. De vraag gaat over haar eigen wimpers, niet over
    // welke kit ze kiest; de kit staat straks voluit in de uitkomst.
    out.push({ value: careKey, label: s.careYes, sub: '' });
    out.push({ value: kitKey, label: s.careNo, sub: '' });
    return out;
  };

  // eerder-besteld-route: de stijlen uit de instellingen (titel, url en foto uit het product zelf)
  proto.quizPrevStyles = function () {
    var s = this.quizStrings || {};
    var list = Array.isArray(s.prevStyles) ? s.prevStyles : [];
    var out = [], i;
    for (i = 0; i < list.length; i++) {
      if (!list[i] || !list[i].title || !list[i].url) continue;
      out.push({ value: String(list[i].handle || i), label: list[i].title, sub: '', url: list[i].url, media: list[i].image ? { src: list[i].image } : null });
    }
    return out;
  };

  proto.quizPlan = function () {
    var s = this.quizStrings || {};
    var a = this.quizAnswers || {};
    var steps = [], i;
    var prev = this.quizPrevStyles();
    if (s.prevQ && s.prevYes && s.prevNo && prev.length > 1) {
      steps.push({ id: 'prev', q: s.prevQ, options: [
        { value: 'no', label: s.prevNo, sub: '' },
        { value: 'yes', label: s.prevYes, sub: s.prevYesSub || '' }
      ] });
      if (a.prev === 'yes') { steps.push({ id: 'prevstyle', q: s.prevStyleQ || '', options: prev, grid: true }); return steps; }
    }
    var look = this.quizLookOptions();
    if (look.length > 1) {
      steps.push({ id: 'look', q: s.q1 || '', options: look });
      // de vervolgvraag hoort alleen in het pad waarin ze gekozen is
      for (i = 0; i < look.length; i++) {
        if (look[i].value === a.look && look[i].follow) steps.push({ id: 'look2', q: look[i].follow.q, options: look[i].follow.options });
      }
    }
    var mms = this.quizMmOptions();
    if (mms.length > 1) steps.push({ id: 'mm', q: s.q2 || '', options: mms, illu: true });
    var care = this.quizCareOptions();
    if (care.length > 1) steps.push({ id: 'care', q: s.careQ || '', options: care });
    return steps;
  };

  /* Vraag 3 koppelt de sets uit de instellingen aan het koopvak; de titel komt van de kaart zelf. */
  proto.setTitle = function (key) {
    var el = this.querySelector('[data-set-label="' + key + '"] .lc__set-title');
    return el ? (el.textContent || '').trim() : '';
  };

  /* De inhoudsregels van een setkaart ("2x lash strips", "1x Toolkit"), 21-09 (opdracht Thomas): de quiz-uitkomst moet
     bovenaan laten zien dat er een hele kit in zit en niet één losse wimper. De tekst komt letterlijk van de kaart in
     het koopvak, zodat de uitkomst nooit iets anders kan beweren dan wat de klant daar ziet. */
  proto.setLines = function (key) {
    var els = this.querySelectorAll('[data-set-label="' + key + '"] .lc__set-regel');
    var out = [], i, t;
    for (i = 0; i < els.length; i++) { t = (els[i].textContent || '').trim(); if (t) out.push(t); }
    return out;
  };

  proto.quizStart = function () {
    this.quizAnswers = {};
    this.quizAt = 0;
    this.quizRender();
  };

  proto.quizAnswer = function (id, value) {
    // een andere look maakt het antwoord op de vervolgvraag ongeldig; een ander antwoord op "eerder besteld" de rest
    if (id === 'look' && this.quizAnswers.look !== value) delete this.quizAnswers.look2;
    if (id === 'prev' && this.quizAnswers.prev !== value) delete this.quizAnswers.prevstyle;
    this.quizAnswers[id] = value;
    this.quizAt += 1;
    this.quizRender();
  };

  /* Oogillustratie voor de wimpervraag: hetzelfde oog, de wimpers worden per antwoord langer (rank 0 = kortst). */
  function eyeSvg(rank, total) {
    var t = total > 1 ? rank / (total - 1) : 1;
    var len = 6.5 + t * 8.5;
    var P0 = [12, 30], P1 = [34, 9], P2 = [56, 30];
    var d = '';
    var us = [0.09, 0.2, 0.32, 0.44, 0.56, 0.68, 0.8, 0.91];
    for (var i = 0; i < us.length; i++) {
      var u = us[i], w = 1 - u;
      var x = w * w * P0[0] + 2 * w * u * P1[0] + u * u * P2[0];
      var y = w * w * P0[1] + 2 * w * u * P1[1] + u * u * P2[1];
      var dx = 2 * w * (P1[0] - P0[0]) + 2 * u * (P2[0] - P1[0]);
      var dy = 2 * w * (P1[1] - P0[1]) + 2 * u * (P2[1] - P1[1]);
      var n = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = dy / n, ny = -dx / n; // naar buiten (omhoog)
      var l = len * (0.8 + 0.2 * Math.sin(u * Math.PI));
      var x2 = x + nx * l, y2 = y + ny * l;
      var cx = x + nx * l * 0.55 + (u - 0.5) * 1.5, cy = y + ny * l * 0.55;
      d += 'M' + x.toFixed(1) + ' ' + y.toFixed(1) + 'Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + x2.toFixed(1) + ' ' + y2.toFixed(1);
    }
    return '<svg viewBox="0 0 68 44" focusable="false" aria-hidden="true">' +
      '<path d="M12 30Q34 9 56 30" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '<path d="M12 30Q34 41 56 30" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" opacity="0.55"/>' +
      '<circle cx="34" cy="27" r="6.2" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
      '<circle cx="34" cy="27" r="2.4" fill="currentColor"/>' +
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>';
  }

  proto.quizRender = function () {
    var box = this.querySelector('[data-help]');
    if (!box) return;
    var body = box.querySelector('[data-quiz-body]');
    if (!body) return;
    var line = box.querySelector('[data-quiz-stepline]');
    var back = box.querySelector('[data-quiz-back]');
    var own = box.querySelector('[data-quiz-own]');
    var s = this.quizStrings || {};
    var steps = this.quizPlan();
    while (body.firstChild) body.removeChild(body.firstChild);
    var klaar = this.quizAt >= steps.length;
    if (klaar) {
      if (line) line.textContent = '';
      this.quizShowResult(body);
    } else {
      var step = steps[this.quizAt];
      if (line) line.textContent = fill(s.step || '', { n: this.quizAt + 1, t: steps.length });
      var h = document.createElement('p');
      h.className = 'lc__quiz-q';
      h.textContent = step.q;
      body.appendChild(h);
      var list = document.createElement('div');
      list.className = 'lc__quiz-opts' + (step.grid ? ' lc__quiz-opts--grid' : '');
      for (var i = 0; i < step.options.length; i++) {
        var o = step.options[i];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lc__quiz-opt' + (step.grid ? ' lc__quiz-opt--card' : '');
        b.setAttribute('data-quiz-pick', step.id);
        b.setAttribute('data-quiz-value', o.value);
        b.setAttribute('aria-pressed', this.quizAnswers[step.id] === o.value ? 'true' : 'false');
        if (step.illu) {
          var ill = document.createElement('span');
          ill.className = 'lc__quiz-opt-illu';
          ill.innerHTML = eyeSvg(i, step.options.length);
          b.appendChild(ill);
          b.classList.add('lc__quiz-opt--media');
        } else if (o.media && o.media.src) {
          /* 21-09 (opdracht Thomas): de foto krijgt een eigen kader. In dat kader kan de CSS op het oog inzoomen
             zonder buiten de afgeronde hoek te lopen; de <img> houdt dezelfde klasse (contract + harness). */
          var frame = document.createElement('span');
          frame.className = 'lc__quiz-opt-frame';
          var im = document.createElement('img');
          im.className = 'lc__quiz-opt-img';
          im.src = o.media.src;
          im.alt = '';
          im.width = 136;
          im.height = 136;
          im.loading = 'lazy';
          im.decoding = 'async';
          frame.appendChild(im);
          b.appendChild(frame);
          if (!step.grid) b.classList.add('lc__quiz-opt--media');
        }
        var txt = document.createElement('span');
        txt.className = 'lc__quiz-opt-text';
        var lab = document.createElement('span');
        lab.className = 'lc__quiz-opt-label';
        lab.textContent = o.label;
        txt.appendChild(lab);
        if (o.sub) {
          var sub = document.createElement('span');
          sub.className = 'lc__quiz-opt-sub';
          sub.textContent = o.sub;
          txt.appendChild(sub);
        }
        b.appendChild(txt);
        list.appendChild(b);
      }
      body.appendChild(list);
    }
    if (back) back.hidden = klaar || this.quizAt === 0;
    if (own) own.hidden = !klaar;
    // het aangeklikte antwoord is net uit de DOM verdwenen; zonder dit valt de focus terug op <body>, werkt Escape
    // niet meer en verliest een toetsenbordgebruiker zijn plek. Alleen als het venster open is (bij het openen zet
    // openHelp() de focus zelf, want dan is het venster op dit moment nog verborgen).
    if (this.helpOpen && (!document.activeElement || document.activeElement === document.body || !box.contains(document.activeElement))) {
      var f = body.querySelector('[data-quiz-pick][aria-pressed="true"]') || body.querySelector('[data-quiz-res]') || body.querySelector('[data-quiz-pick]');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }
    // de uitleg over de lengtes hoort alleen bij de lengtevraag, anders maakt hij elke stap onnodig lang
    var uitleg = box.querySelector('[data-quiz-lengths]');
    if (uitleg) uitleg.hidden = klaar || steps[this.quizAt].id !== 'mm';
  };

  /* Uitkomst voor wie al klant is: geen kit maar de 3 + 2 actie van de stijl die ze al kennen. */
  proto.quizShowDeal = function (body, pick) {
    var s = this.quizStrings || {};
    var kop = document.createElement('p');
    kop.className = 'lc__quiz-reshead';
    kop.textContent = s.dealTitle || '';
    body.appendChild(kop);
    var card = document.createElement('div');
    card.className = 'lc__quiz-res';
    card.setAttribute('data-quiz-res', '');
    card.setAttribute('tabindex', '-1');
    if (pick.media && pick.media.src) {
      var img = document.createElement('img');
      img.className = 'lc__quiz-res-img';
      img.width = 400; img.height = 400; img.loading = 'lazy'; img.decoding = 'async'; img.alt = '';
      img.src = pick.media.src;
      card.appendChild(img);
    }
    var txt = document.createElement('div');
    txt.className = 'lc__quiz-res-body';
    var nm = document.createElement('p');
    nm.className = 'lc__quiz-res-name';
    nm.textContent = pick.label + ' · 3 + 2 gratis';
    txt.appendChild(nm);
    if (s.dealText) {
      var wy = document.createElement('p');
      wy.className = 'lc__quiz-res-why';
      wy.textContent = fill(s.dealText, { stijl: pick.label });
      txt.appendChild(wy);
    }
    card.appendChild(txt);
    body.appendChild(card);
    var link = document.createElement('a');
    link.className = 'lc__quiz-add';
    link.setAttribute('data-quiz-deal', '');
    link.href = pick.url;
    link.textContent = fill(s.dealCta || '', { stijl: pick.label }) || pick.label;
    body.appendChild(link);
    var again = document.createElement('button');
    again.type = 'button';
    again.className = 'lc__quiz-again';
    again.setAttribute('data-quiz-restart', '');
    again.textContent = s.restart || '';
    body.appendChild(again);
    this.beacon('cfg_quiz_deal', { style: pick.value });
  };

  /* De uitkomst: de stijl waar de antwoorden op uitkomen, in de lengte die bij de eigen wimpers past. Is die
     combinatie uitverkocht, dan dezelfde stijl in de meest gekozen of de eerstvolgende lengte die er wel is; bestaat
     de stijl niet op deze pagina, dan de eerste stijl uit dezelfde categorie die de lengte op voorraad heeft. De keuze
     wordt meteen in de configurator gezet, zodat de knop hieronder precies hetzelfde toevoegt als de knop op de
     pagina zelf. Wie al klant is krijgt in plaats daarvan de 3 + 2 actie van de stijl die ze noemde. */
  proto.quizShowResult = function (body) {
    var s = this.quizStrings || {};
    var a = this.quizAnswers || {};
    var styles = this.styles || [];
    var i, L;
    if (a.prev === 'yes') {
      var prev = this.quizPrevStyles(), gekozen = null;
      for (i = 0; i < prev.length; i++) if (prev[i].value === a.prevstyle) gekozen = prev[i];
      if (gekozen) { this.quizShowDeal(body, gekozen); return; }
    }
    var mm = String(a.mm || this.state.length);
    var want = null, why = [];
    var look = this.quizLookOptions(), chosen = null;
    for (i = 0; i < look.length; i++) if (look[i].value === a.look) chosen = look[i];
    if (chosen) {
      why.push(chosen.label);
      if (chosen.style) want = chosen.style;
      else if (chosen.follow) {
        for (i = 0; i < chosen.follow.options.length; i++) {
          if (chosen.follow.options[i].value === a.look2) { want = chosen.follow.options[i].style; why.push(chosen.follow.options[i].label); }
        }
      }
    }
    var mms = this.quizMmOptions();
    for (i = 0; i < mms.length; i++) if (mms[i].value === a.mm) why.push(mms[i].label);
    // minimale lengte per stijl (15-09, opdracht Thomas): wie volume wil moet niet op 10 mm uitkomen; de stijl draagt
    // die grens (blokinstelling quiz_min_mm), zodat de quiz nooit korter kiest dan die stijl vraagt
    var minMm = want && Number(want.quizMinMm) > 0 ? Number(want.quizMinMm) : 0;
    var bumped = false;
    if (minMm && Number(mm) < minMm) { mm = String(minMm); bumped = true; }
    var pick = null;
    if (want) {
      L = this.lengthOf(want, mm);
      if (L && L.available) pick = want;
      else {
        var order = [String(this.cfg.popularLength || '')];
        for (i = 0; i < want.lengths.length; i++) order.push(String(want.lengths[i].mm));
        for (i = 0; i < order.length && !pick; i++) {
          L = this.lengthOf(want, order[i]);
          if (L && L.available) { pick = want; mm = order[i]; }
        }
      }
    }
    var cat = want ? want.category : null;
    for (i = 0; i < styles.length && !pick; i++) {
      if (cat && styles[i].category !== cat) continue;
      L = this.lengthOf(styles[i], mm);
      if (L && L.available) pick = styles[i];
    }
    if (!pick) pick = want || this.currentStyle() || styles[0];
    if (!pick) return;
    if (!this.lengthOf(pick, mm) && pick.lengths.length) mm = String(pick.lengths[0].mm);
    this.set({ style: pick.key, length: mm }, 'quiz');
    // bij een kit met twee strips krijgen beide strips de aanbevolen lengte; een eerder met de hand gekozen tweede
    // lengte zou anders stilletjes in de uitkomst blijven staan
    this.state.length2 = mm;
    // de set: het antwoord op de verzorgingsvraag, anders de standaardset uit de instellingen (als die bestaat)
    var setKey = a.care || ((s.kitSet && this.querySelector('input[data-set][value="' + s.kitSet + '"]')) ? s.kitSet : '');
    if (setKey) this.setSet(setKey, false);
    var careOpts = this.quizCareOptions();
    for (i = 0; i < careOpts.length; i++) if (careOpts[i].value === a.care) why.push(careOpts[i].label);

    var v = this.current();
    var kop = document.createElement('p');
    kop.className = 'lc__quiz-reshead';
    kop.textContent = s.result || '';
    body.appendChild(kop);
    /* 21-09 (opdracht Thomas): meteen onder de kop staat dat de hele kit meekomt, met de inhoud van de setkaart
       zelf. Zonder inhoud (bijvoorbeeld een losse strip) blijft de regel weg in plaats van half leeg te staan. */
    var setNaam = setKey ? this.setTitle(setKey) : '';
    var inhoud = setKey ? this.setLines(setKey) : [];
    if (s.resultSub && inhoud.length) {
      var sr = document.createElement('p');
      sr.className = 'lc__quiz-ressub';
      sr.textContent = fill(s.resultSub, { inhoud: inhoud.join(' · '), set: setNaam });
      body.appendChild(sr);
    }
    var card = document.createElement('div');
    card.className = 'lc__quiz-res';
    card.setAttribute('data-quiz-res', '');
    card.setAttribute('tabindex', '-1'); // krijgt de focus na de laatste vraag, zodat een screenreader de aanbeveling voorleest
    var img = document.createElement('img');
    img.className = 'lc__quiz-res-img';
    img.width = 400;
    img.height = 400;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = '';
    img.src = (v.image && v.image.src) || (pick.preview && pick.preview.src) || '';
    card.appendChild(img);
    var txt = document.createElement('div');
    txt.className = 'lc__quiz-res-body';
    var nm = document.createElement('p');
    nm.className = 'lc__quiz-res-name';
    /* 21-09 (opdracht Thomas): de set staat vooraan in de naam ("Premium Starterkit met Anne Fleur 12 mm"), anders
       leest de uitkomst als één losse wimper. Zonder set of zonder de instelling blijft de oude regel staan. */
    var naamUitSet = !!(setNaam && s.resultName);
    nm.textContent = naamUitSet ? fill(s.resultName, { set: setNaam, stijl: pick.title, mm: mm }) : pick.title + ' · ' + mm + ' mm';
    txt.appendChild(nm);
    var meta = [];
    if (pick.descriptor || pick.categoryLabel) meta.push(pick.descriptor || pick.categoryLabel);
    // de set staat dan al voluit in de naam; hem hier herhalen maakte de kaart alleen langer
    if (setKey && !naamUitSet) { var st = this.setTitle(setKey); if (st) meta.push(st); }
    if (meta.length) {
      var cat2 = document.createElement('p');
      cat2.className = 'lc__quiz-res-cat';
      cat2.textContent = meta.join(' · ');
      txt.appendChild(cat2);
    }
    if (why.length && s.why) {
      var wy = document.createElement('p');
      wy.className = 'lc__quiz-res-why';
      wy.textContent = s.why + ': ' + why.join(' · ');
      txt.appendChild(wy);
    }
    if (bumped && s.minNote) {
      var mn = document.createElement('p');
      mn.className = 'lc__quiz-res-why';
      mn.textContent = fill(s.minNote, { stijl: pick.title, mm: String(minMm) });
      txt.appendChild(mn);
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lc__quiz-add';
    btn.setAttribute('data-atc', '');
    btn.setAttribute('data-atc-quiz', '');
    var blab = document.createElement('span');
    blab.setAttribute('data-atc-label', '');
    btn.appendChild(blab);
    var bprice = document.createElement('span');
    bprice.className = 'lc__quiz-add-price';
    btn.appendChild(bprice);
    var again = document.createElement('button');
    again.type = 'button';
    again.className = 'lc__quiz-again';
    again.setAttribute('data-quiz-restart', '');
    again.textContent = s.restart || '';
    card.appendChild(txt);
    body.appendChild(card);
    body.appendChild(btn);
    body.appendChild(again);

    // render() vult het label en de beschikbaarheid van elke [data-atc]; de prijs komt uit de knop op de pagina
    // zelf, zodat hier nooit een ander bedrag kan staan dan wat de klant daadwerkelijk betaalt.
    this.render(false);
    var bron = this.querySelector('[data-atc]:not([data-atc-sticky]):not([data-atc-quiz]) [data-atc-price]');
    bprice.textContent = bron && !bron.hidden ? (bron.textContent || '') : '';
    this.beacon('cfg_quiz_done', { style: pick.key, length: mm, set: setKey || this.state.set, look: a.look || '', look2: a.look2 || '', care: a.care || '', min: bumped ? minMm : 0 });
  };

  proto.openHelp = function (opener) {
    var box = this.querySelector('[data-help]');
    if (!box) return;
    this.helpOpener = opener || null;
    this.quizStart();
    box.hidden = false;
    box.removeAttribute('inert');
    document.documentElement.classList.add('lc-story-open');
    this.helpOpen = true;
    var bar1 = this.querySelector('[data-sticky]');
    if (bar1) this.updateSticky(bar1);
    this.guardChat();
    var first = box.querySelector('[data-quiz-pick][aria-pressed="true"]') || box.querySelector('[data-quiz-pick]') || box.querySelector('[data-help-close]');
    if (first) first.focus();
    this.beacon('cfg_help_open', { style: this.state.style });
  };

  proto.closeHelp = function () {
    var box = this.querySelector('[data-help]');
    if (!box || box.hidden) return;
    box.hidden = true;
    box.setAttribute('inert', '');
    document.documentElement.classList.remove('lc-story-open');
    this.helpOpen = false;
    var bar2 = this.querySelector('[data-sticky]');
    if (bar2) this.updateSticky(bar2);
    this.guardChat();
    if (this.helpOpener && this.helpOpener.focus) this.helpOpener.focus();
    this.helpOpener = null;
  };

  proto.setupStory = function () {
    var self = this;
    var root = this.querySelector('[data-story]');
    if (!root || !this.cfg.landingStory) return;
    var itemsEl = root.querySelector('[data-story-items]');
    try { this.storyItems = JSON.parse(itemsEl ? itemsEl.textContent : '[]'); } catch (e) { this.storyItems = []; }
    if (!this.storyItems.length) return;
    this.storyRoot = root;
    this.storyVideo = root.querySelector('[data-story-video]');
    this.storyOpen = false;
    this.storyMuted = false;
    var s = this.cfg.strings;
    var thumbs = root.querySelector('[data-story-thumbs]');
    if (thumbs) {
      var html = '';
      for (var i = 0; i < this.storyItems.length; i++) {
        var it = this.storyItems[i];
        html += '<button type="button" class="lc__story-thumb" data-story-go="' + esc(it.i) + '" aria-current="false" aria-label="' +
          esc(fill(s.storyOf, { n: i + 1, total: this.storyItems.length })) + ': ' + esc(it.title) + '">' +
          (it.thumb ? '<img src="' + esc(it.thumb) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '<span></span>') + '</button>';
      }
      thumbs.innerHTML = html;
    }
    var v = this.storyVideo;
    var opts = { signal: this.ac.signal };
    var prog = root.querySelector('[data-story-progress]');
    v.addEventListener('timeupdate', function () { self.updateStoryProgress(); }, opts);
    v.addEventListener('ended', function () {
      if (!self.storyOpen) return;
      var idx = 0;
      for (var k = 0; k < self.storyItems.length; k++) if (String(self.storyItems[k].i) === String(self.storyIndex)) idx = k;
      self.loadStory(self.storyItems[(idx + 1) % self.storyItems.length].i);
    }, opts);
    if (prog) {
      prog.addEventListener('input', function () {
        if (v.duration) v.currentTime = v.duration * (parseInt(prog.value, 10) || 0) / 1000;
      }, opts);
    }
    var tap = root.querySelector('[data-story-tap] span');
    if (tap) tap.textContent = s.storyTapSound || '';
    this.applyStoryMute();
  };

  proto.openStory = function (i, opener) {
    if (!this.storyRoot || this.storyOpen) return;
    this.storyOpener = opener || null;
    this.storyOpen = true;
    var loops = this.querySelectorAll(LOOP_SEL);
    for (var k = 0; k < loops.length; k++) if (!loops[k].paused) loops[k].pause();
    this.storyRoot.hidden = false;
    this.storyRoot.removeAttribute('inert');
    document.documentElement.classList.add('lc-story-open');
    this.loadStory(i);
    var focusTarget = this.storyRoot.querySelector('button[data-story-close]') || this.storyRoot.querySelector('[role="dialog"]');
    try { focusTarget.focus({ preventScroll: true }); } catch (e) {}
    this.updateStickyNow();
    this.guardChat(false);
    this.beacon('cfg_story', { i: i });
  };

  proto.loadStory = function (i) {
    if (!this.storyRoot) return;
    var self = this;
    var it = null;
    for (var j = 0; j < this.storyItems.length; j++) if (String(this.storyItems[j].i) === String(i)) it = this.storyItems[j];
    if (!it) it = this.storyItems[0];
    this.storyIndex = it.i;
    var v = this.storyVideo;
    v.pause();
    if (it.poster) v.setAttribute('poster', it.poster); else v.removeAttribute('poster');
    v.setAttribute('src', it.src);
    var heading = this.storyRoot.querySelector('[data-story-heading]');
    if (heading) heading.textContent = it.title || '';
    var caption = this.storyRoot.querySelector('[data-story-caption]');
    if (caption) caption.textContent = it.title || '';
    var ths = this.storyRoot.querySelectorAll('[data-story-go]');
    for (var t = 0; t < ths.length; t++) {
      var on = ths[t].getAttribute('data-story-go') === String(it.i);
      ths[t].classList.toggle('is-active', on);
      ths[t].setAttribute('aria-current', on ? 'true' : 'false');
    }
    var prog = this.storyRoot.querySelector('[data-story-progress]');
    if (prog) { prog.value = 0; prog.setAttribute('aria-valuetext', '0%'); }
    this.showStoryTap(false);
    v.muted = !!this.storyMuted;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        // autoplay met geluid geweigerd: zonder geluid afspelen en een tik-hint tonen
        if (!v.muted) {
          v.muted = true;
          self.showStoryTap(true);
          var p2 = v.play();
          if (p2 && p2.catch) p2.catch(function () {});
        }
      });
    }
  };

  proto.closeStory = function () {
    if (!this.storyRoot || !this.storyOpen) return;
    var v = this.storyVideo;
    v.pause();
    v.removeAttribute('src');
    v.removeAttribute('poster');
    try { v.load(); } catch (e) {}
    this.storyRoot.hidden = true;
    this.storyRoot.setAttribute('inert', '');
    document.documentElement.classList.remove('lc-story-open');
    this.storyOpen = false;
    this.showStoryTap(false);
    var op = this.storyOpener;
    this.storyOpener = null;
    if (op) { try { op.focus({ preventScroll: true }); } catch (e) {} }
    var loops = this.querySelectorAll(LOOP_SEL);
    for (var k = 0; k < loops.length; k++) if (loops[k].dataset.inView === '1') this.playLoop(loops[k]);
    this.updateStickyNow();
    this.guardChat(false);
  };

  proto.updateStoryProgress = function () {
    var v = this.storyVideo;
    var prog = this.storyRoot && this.storyRoot.querySelector('[data-story-progress]');
    if (!v || !prog || !v.duration) return;
    var pct = v.currentTime / v.duration;
    prog.value = Math.round(pct * 1000);
    prog.setAttribute('aria-valuetext', Math.round(pct * 100) + '%');
  };

  proto.toggleStoryMute = function () {
    this.storyMuted = !this.storyMuted;
    this.applyStoryMute();
    if (!this.storyMuted) this.showStoryTap(false);
  };

  proto.applyStoryMute = function () {
    var s = this.cfg.strings;
    var btn = this.storyRoot && this.storyRoot.querySelector('[data-story-mute]');
    if (this.storyVideo) this.storyVideo.muted = !!this.storyMuted;
    if (btn) {
      btn.setAttribute('aria-pressed', this.storyMuted ? 'true' : 'false');
      btn.setAttribute('aria-label', this.storyMuted ? (s.storyMuteOff || 'Geluid aan') : (s.storyMuteOn || 'Geluid uit'));
    }
  };

  proto.showStoryTap = function (show) {
    var tap = this.storyRoot && this.storyRoot.querySelector('[data-story-tap]');
    if (tap) tap.hidden = !show;
  };

  proto.updateStickyNow = function () {
    var bar = this.querySelector('[data-sticky]');
    if (bar) this.updateSticky(bar);
  };

  /* ---------- R2A: Trustpilot TrustBox (alleen met snippet; pas na load + idle; fallback blijft tot het iframe hoogte heeft) ---------- */

  proto.setupTrustpilot = function () {
    var self = this;
    var r = this.cfg.rating;
    var line = this.querySelector('[data-rating]');
    var wrap = this.querySelector('[data-rating-widget]');
    if (!r || r.source !== 'trustpilot' || !r.widget || !line || !wrap || this.cfg.mode === 'prelaunch') return;
    var els = Array.prototype.slice.call(this.querySelectorAll('[data-rating-widget] .trustpilot-widget, [data-rating-widget-2] .trustpilot-widget'));
    if (!els.length) return;
    // 'is-ready' verbergt onze eigen sterren; dat mag alleen als de TrustBox in DIE regel zelf geladen is
    var el = wrap.querySelector('.trustpilot-widget');
    var run = function () {
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 800); };
      idle(function () {
        if (self.tpLoaded) return;
        self.tpLoaded = true;
        var sc = document.createElement('script');
        try { window.__lcTpAt = Date.now(); } catch (e0) {}
        sc.setAttribute('data-lc-tp', '1');
        sc.src = TP_SCRIPT;
        sc.async = true;
        sc.onload = function () {
          try {
            if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') { for (var wi = 0; wi < els.length; wi++) window.Trustpilot.loadFromElement(els[wi], true); }
          } catch (e) { return; }
          var tries = 0;
          var iv = setInterval(function () {
            var f = el ? el.querySelector('iframe') : null;
            if (f && f.getBoundingClientRect().height > 10) { clearInterval(iv); line.classList.add('is-ready'); }
            else if (++tries > 40) clearInterval(iv);
          }, 250);
        };
        document.head.appendChild(sc);
      });
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true, signal: this.ac.signal });
  };

  

  proto.renderScarcity = function (v) {
    var boxes = this.querySelectorAll('[data-scarcity], [data-scarcity-copy]');
    for (var bi = 0; bi < boxes.length; bi++) this.renderScarcityBox(boxes[bi], v);
  };

  proto.renderScarcityBox = function (box, v) {
    if (!box) return;
    var sc = this.cfg.scarcity || {};
    var stock = box.querySelector('[data-scarcity-stock]');
    if (stock) {
      var thr = sc.stockThreshold || 100;
      var n = (v && typeof v.stockShown === 'number' && v.stockShown > 0 && v.stockShown < thr) ? v.stockShown : null;
      if (n !== null) {
        stock.textContent = fill(this.cfg.strings.stockLeft || 'Nog {n} op voorraad', { n: n });
        stock.hidden = false;
      } else {
        stock.hidden = true;
        stock.textContent = '';
      }
    }
    var segs = box.querySelectorAll('[data-scarcity-seg]');
    for (var i = 0; i < segs.length; i++) segs[i].classList.toggle('is-active', segs[i].getAttribute('data-scarcity-seg') === String(this.state.length));
    // R2E campagne: echt percentage per gekozen SKU uit de config (baseline op de startdatum vs. actuele voorraad);
    // null (fail-closed) of onder de drempel = geen percentage en lege vulling
    var row = box.querySelector('[data-scarcity-sold-row]');
    if (row) {
      var c = v && v.campaign;
      var pct = 93;
      var min = typeof sc.minPct === 'number' ? sc.minPct : 0;
      var show = true;
      this.setSoldRow(row, show ? pct : 0, show);
    }
    // 12-09: rechtercel van de tweede rij ("0% verkocht" van de volgende levering) alleen zolang dat voor de gekozen SKU
    // aantoonbaar waar is (config.nextSoldZero: voorraad > 0 en DENY op shell én origineel); anders verborgen
    var nz = box.querySelector('[data-scarcity-next-zero]');
    if (nz) nz.hidden = !(v && v.nextSoldZero === true);
  };

  // De balk loopt op zodra hij voor het eerst in beeld komt: van 0 naar het echte percentage, met het getal mee
  // (opdracht Thomas 14-09). De eindwaarde komt onveranderd uit de config; de animatie is alleen de weg ernaartoe.
  // Alleen de eerste onthulling beweegt: daarna (andere stijl/lengte) springt de balk direct naar de nieuwe waarde,
  // zodat wisselen niet elke keer opnieuw telt en de gates een stabiele eindstand lezen.
  proto.setSoldRow = function (row, target, show) {
    var sold = row.querySelector('[data-scarcity-sold]');
    var tmpl = (this.cfg.strings && this.cfg.strings.soldPct) || '{n}% verkocht';
    var write = function (n) {
      row.style.setProperty('--lc-sold', n + '%');
      if (!sold) return;
      sold.hidden = !show;
      sold.textContent = show ? fill(tmpl, { n: n }) : '';
    };
    if (row._lcRaf) { cancelAnimationFrame(row._lcRaf); row._lcRaf = null; row.classList.remove('is-filling'); }
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var canAnim = show && target > 0 && !reduce && typeof requestAnimationFrame === 'function';
    if (!canAnim || row._lcSeen) { row._lcSeen = true; write(target); return; }
    // breedte van de tekst vastzetten op de eindstand, anders verspringt de regel tijdens het tellen (CLS)
    if (sold) {
      sold.hidden = false;
      sold.textContent = fill(tmpl, { n: target });
      var w = sold.getBoundingClientRect().width;
      if (w) sold.style.minWidth = Math.ceil(w) + 'px';
    }
    write(0);
    var run = function () {
      row._lcSeen = true;
      row.classList.add('is-filling');
      var t0 = 0, dur = 1100;
      var step = function (ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        write(Math.round(target * (1 - Math.pow(1 - k, 3))));
        if (k < 1) { row._lcRaf = requestAnimationFrame(step); return; }
        row._lcRaf = null;
        row.classList.remove('is-filling');
        write(target);
      };
      row._lcRaf = requestAnimationFrame(step);
    };
    if (typeof IntersectionObserver !== 'function') { run(); return; }
    if (row._lcIo) return;
    row._lcIo = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        if (row._lcIo) { row._lcIo.disconnect(); row._lcIo = null; }
        run();
        return;
      }
    }, { threshold: 0.4 });
    row._lcIo.observe(row);
  };

  /* ---------- R2E: doorgestreepte losse prijs in de knop, alleen in de 3 + 2-stand en alleen als de losse prijs echt hoger is ---------- */

  proto.renderAtcCompare = function () {
    var btn = this.querySelector('[data-atc]:not([data-atc-sticky])');
    if (!btn) return;
    var cmp = btn.querySelector('[data-atc-compare]');
    var pill = btn.querySelector('[data-atc-pill]');
    var price = btn.querySelector('[data-atc-price]');
    if (pill && price) pill.hidden = !!price.hidden;
    if (!cmp) return;
    var loose = null;
    var akit = this.kitByKey(this.state.set);
    if (akit && akit.showCompare) { var kt = this.kitTotals(akit, this.current()); loose = kt && kt.compare ? kt.compare : null; }
    if (this.state.set === 'starter' && this.cfg.starter) {
      var sv = this.current(), st0 = this.starterTotal(sv);
      if (st0 !== null && typeof sv.price === 'number') { loose = sv.price + this.cfg.starter.toolkit.price; if (loose <= st0) loose = null; }
    }
    if (this.state.set === 'bundle' && this.cfg.bundle && this.state.slots && this.state.slots.length) {
      var t = this.bundleTotals();
      if (t && t.ok) {
        loose = 0;
        for (var i = 0; i < this.state.slots.length; i++) {
          var sl = this.state.slots[i];
          var st = this.styleMap[sl.style];
          var L = null;
          if (st) for (var j = 0; j < st.lengths.length; j++) if (String(st.lengths[j].mm) === String(sl.length)) L = st.lengths[j];
          if (!L || typeof L.price !== 'number') { loose = null; break; }
          loose += L.price;
        }
        if (loose !== null && loose <= t.total) loose = null;
      }
    }
    if (loose === null || (price && price.hidden)) { cmp.hidden = true; cmp.textContent = ''; return; }
    cmp.innerHTML = '<span class="visually-hidden">' + esc(this.cfg.strings.looseSr || 'los ') + '</span>' + esc(this.money(loose));
    cmp.hidden = false;
  };

  proto.captionFor = function (style, v) {
    var s = this.cfg.strings;
    if (v && v.hasOwnImage) return fill(s.captionExact, { style: style.title, mm: this.state.length });
    var a = style.closeupLengths && style.closeupLengths[0];
    var b = style.closeupLengths && style.closeupLengths[1];
    if (a != null && b != null) return fill(s.captionMix, { style: style.title, a: a, b: b });
    return style.title;
  };

  proto.setAtcAvailability = function (available, style) {
    var s = this.cfg.strings;
    var buttons = this.querySelectorAll('[data-atc]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.disabled = !available;
      var label = btn.querySelector('[data-atc-label]');
      var isSticky = btn.hasAttribute('data-atc-sticky');
      if (this.cfg.picker && btn.hasAttribute('data-picker-open')) { btn.disabled = false; continue; } // R2G: opener blijft altijd bruikbaar
      if (this.cfg.picker && btn.hasAttribute('data-atc-single')) {
        var sp = btn.querySelector('[data-atc-price-single]');
        if (label) label.textContent = available ? (s.singleLink || 'Liever 1 strip? Voeg toe voor') : s.soldOut;
        if (sp) { sp.hidden = !available; sp.textContent = this.current().priceFormatted || ''; }
        continue;
      }
      // sticky knop: altijd het korte label ("In winkelwagen"), zodat de gekozen look ernaast niet afgekapt wordt (jury R2E, C5)
      var shortLabel = isSticky;
      var txt = available ? (shortLabel ? s.addToCartShort : s.addToCart) : s.soldOut;
      if (label) label.textContent = txt; else btn.textContent = txt;
      var price = btn.querySelector('[data-atc-price]');
      if (price) price.hidden = !available;
    }
    var help = this.querySelector('[data-soldout]');
    if (help) {
      if (available) {
        help.hidden = true; help.textContent = '';
      } else {
        help.hidden = false;
        help.textContent = fill(s.soldOutHelp, { style: style.title, mm: this.state.length });
      }
    }
  };

  proto.setState = function (state) {
    this.dataset.state = state;
    this.classList.toggle('is-busy', state === 'busy');
  };

  /* ---------- afbeeldingen ---------- */

  // 16-09: de grote viewer toont de hoofdafbeelding van de stijl (style.hero, leeg = preview). Een lengte met een eigen
  // variantfoto wint nog steeds, en alle kleine beelden (kaartjes, thumbnails, picker, vergelijking, quiz) blijven preview.
  proto.imageFor = function (style, v) {
    // 16-09 (opdracht Thomas): de grote foto hoort bij de gekozen KIT, niet bij de stijl. Basic toont een strip,
    // Premium twee, Deluxe twee plus serum. Heeft een kit geen eigen foto, dan valt hij terug op de stijl.
    var kit = this.kitByKey ? this.kitByKey(this.state.set) : null;
    if (kit && kit.hero && kit.hero.src) return kit.hero;
    if (v && v.hasOwnImage && v.image) return v.image;
    return style.hero || style.preview;
  };

  proto.preload = function (img) {
    if (!img || !img.src) return Promise.resolve();
    if (this.imgCache[img.src]) return this.imgCache[img.src];
    var el = new Image();
    if (img.sizes) el.sizes = img.sizes;
    if (img.srcset) el.srcset = img.srcset;
    el.src = img.src;
    var p = (el.decode ? el.decode() : new Promise(function (r) { el.onload = r; el.onerror = r; })).catch(function () {});
    this.imgCache[img.src] = p;
    return p;
  };

  proto.swapImage = function (img) {
    var self = this;
    var imgs = this.querySelectorAll('.lc__img');
    if (imgs.length < 2 || !img) return;
    var active = imgs[0].classList.contains('is-active') ? imgs[0] : imgs[1];
    var next = active === imgs[0] ? imgs[1] : imgs[0];
    if (stripQuery(active.getAttribute('src')) === stripQuery(img.src)) return;
    var token = (this.swapToken = (this.swapToken || 0) + 1);
    var timeout = new Promise(function (r) { setTimeout(r, 300); });
    Promise.race([this.preload(img), timeout]).then(function () {
      if (token !== self.swapToken) return;
      next.sizes = img.sizes || '';
      if (img.srcset) next.srcset = img.srcset; else next.removeAttribute('srcset');
      next.src = img.src;
      next.alt = img.alt || '';
      next.removeAttribute('aria-hidden');
      active.setAttribute('aria-hidden', 'true');
      var apply = function () {
        next.classList.add('is-active');
        active.classList.remove('is-active');
      };
      if (self.reduced) apply(); else requestAnimationFrame(apply);
    });
  };

  proto.setupWarmup = function () {
    var self = this;
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(String(c.effectiveType || '')))) return;
    var run = function () {
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      idle(function () {
        for (var i = 0; i < self.styles.length; i++) {
          if (self.styles[i].key !== self.state.style) self.preload(self.styles[i].hero || self.styles[i].preview);
        }
      });
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true, signal: this.ac.signal });
  };

  /* ---------- vergelijken ---------- */

  proto.toggleCompare = function () {
    var box = this.querySelector('[data-compare]');
    var btn = this.querySelector('[data-compare-toggle]');
    var stage = this.querySelector('[data-stage]');
    if (!box || !btn) return;
    this.state.compare = !this.state.compare;
    var s = this.cfg.strings;
    btn.setAttribute('aria-pressed', this.state.compare ? 'true' : 'false');
    btn.textContent = this.state.compare ? s.compareOff : s.compareOn;
    this.classList.toggle('is-comparing', this.state.compare);
    box.hidden = !this.state.compare;
    if (stage) stage.hidden = this.state.compare;
    if (this.state.compare) {
      this.renderCompare();
      var cur = this.currentStyle(), prev = this.styleMap[this.state.prevStyle] || cur;
      this.announce(fill(s.compareLive, { style: cur.title, style2: prev.title }));
      this.beacon('cfg_compare', { style: cur.key, previous: prev.key });
    } else {
      this.announce(s.compareLiveOff);
    }
  };

  proto.renderCompare = function () {
    var s = this.cfg.strings;
    var cur = this.currentStyle();
    var prevKey = this.state.prevStyle && this.state.prevStyle !== cur.key ? this.state.prevStyle : this.neighbourStyle(cur.key);
    var prev = this.styleMap[prevKey] || cur;
    var pairs = [['current', cur], ['previous', prev]];
    for (var i = 0; i < pairs.length; i++) {
      var img = this.querySelector('[data-compare-img="' + pairs[i][0] + '"]');
      var chip = this.querySelector('[data-chip="' + pairs[i][0] + '"]');
      var style = pairs[i][1];
      if (img && stripQuery(img.getAttribute('src')) !== stripQuery(style.preview.src)) {
        img.srcset = style.preview.srcset || '';
        img.sizes = '(min-width: 990px) 32rem, 50vw';
        img.src = style.preview.src;
        img.alt = style.preview.alt || style.title;
      }
      if (chip) {
        var mix = style.closeupLengths && style.closeupLengths.length === 2 ? ' (' + style.closeupLengths[0] + ' & ' + style.closeupLengths[1] + ' mm)' : '';
        chip.textContent = (pairs[i][0] === 'current' ? s.chosen : s.previous) + ' · ' + style.title + mix;
      }
    }
  };

  /* ---------- winkelwagen ---------- */

  proto.addToCart = function (btn) {
    if (this.cfg.picker && btn && btn.hasAttribute('data-picker-open')) return this.openPicker(btn);
    if (this.cfg.picker && btn && btn.hasAttribute('data-atc-single')) return this.addSingleToCart(btn);
    if (this.state.set === 'bundle' && this.cfg.bundle) return this.addBundleToCart(btn);
    if (this.state.set === 'starter' && this.cfg.starter) return this.addStarterToCart(btn);
    if (this.state.set === 'wimperplan' && this.planAvailable()) return this.addPlanToCart(btn);
    var kit = this.kitByKey(this.state.set);
    if (kit) return this.addKitToCart(btn, kit);
    return this.addSingleToCart(btn);
  };

  proto.addSingleToCart = function (btn) {
    var self = this;
    var v = this.current();
    var style = this.currentStyle();
    var s = this.cfg.strings;
    if (!v.variantId || !v.available || btn.disabled || this.cartPending || this.dataset.state === 'busy') return;
    this.cartPending = true;
    var root = this.cfg.cartRoot || '/';
    this.setBusy(btn, true);
    this.hideError();

    var precheck = window.fetch(root + 'products/' + v.originalHandle + '.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !Array.isArray(p.variants)) throw new Error();
        for (var i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === String(v.originalVariantId)) return p.variants[i].available === true;
        }
        throw new Error();
      });

    precheck.then(function (ok) {
      if (!ok) { self.markSoldOut(style, v); return null; }
      return window.fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.variantId, quantity: 1 }] })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (r.status === 422 || (data && data.status === 422)) { self.markSoldOut(style, v); return null; }
          if (!r.ok) throw new Error(data && (data.description || data.message) || ('HTTP ' + r.status));
          return data;
        });
      }).then(function (data) {
        if (!data) return;
        self.setState('added');
        var allBtns = self.querySelectorAll('[data-atc]');
        for (var bi = 0; bi < allBtns.length; bi++) self.setAtcLabel(allBtns[bi], s.added);
        self.announce(fill(s.liveAdded, { style: style.title, mm: self.state.length }));
        self.beacon('cfg_add', { style: style.key, length: self.state.length, variant: v.variantId });
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lash-configurator', productVariantId: v.variantId, cartData: data }); } catch (e) {}
        }
        self.openCart();
        clearTimeout(self.addedTimer);
        self.addedTimer = setTimeout(function () {
          if (self.dataset.state === 'added') { self.setState('idle'); self.setAtcAvailability(true, style); }
        }, ADDED_MS);
      });
    }).catch(function (err) {
      self.setState('error');
      self.showError(s.error + (err && err.message ? ' (' + err.message + ')' : ''));
      self.beacon('cfg_add_error', { msg: String(err && err.message || '').slice(0, 80) });
    }).then(function () {
      self.cartPending = false;
      self.setBusy(btn, false);
    });
  };

  /* ---------- R2D: 3 + 2-set (Insider-varianten, bestaande automatische korting) ---------- */

  proto.setSet = function (value, silent) {
    if (!this.cfg.bundle && value === 'bundle') value = 'single';
    if (!this.cfg.starter && value === 'starter') value = 'single';
    if (value === 'wimperplan' && !this.planAvailable()) value = 'single';
    if (value !== 'single' && value !== 'bundle' && value !== 'starter' && value !== 'wimperplan' && !this.kitByKey(value)) value = 'single';
    this.kitSoldOut = false;
    var changed = value !== this.state.set;
    this.state.set = value;
    this.bundleSoldOut = false;
    this.starterSoldOut = false;
    if (value === 'bundle' && !this.state.slots) {
      this.state.slots = [];
      for (var i = 0; i < this.cfg.bundle.size; i++) this.state.slots.push({ style: this.state.style, length: this.state.length });
      this.state.activeSlot = 0;
    }
    if (value === 'bundle' && this.state.slots) {
      var a = this.state.slots[this.state.activeSlot];
      this.state.style = a.style;
      this.state.length = a.length;
    }
    var radio = this.querySelector('input[data-set][value="' + value + '"]');
    if (radio && !radio.checked) radio.checked = true;
    this.dataset.set = value;
    var slots = this.querySelector('[data-slots]');
    if (slots) slots.hidden = value !== 'bundle';
    this.render(false);
    if (changed && !silent) {
      var lab = this.querySelector('label[data-set-label="' + value + '"] .lc__set-title');
      this.announce(fill(this.cfg.strings.liveSet || '{label}', { label: lab ? lab.textContent.trim() : value }));
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'lash_configurator_set', lc_set: value });
      this.beacon('cfg_set', { set: value });
    }
  };

  proto.setActiveSlot = function (idx) {
    if (this.state.set !== 'bundle' || !this.state.slots || !this.state.slots[idx]) return;
    this.state.activeSlot = idx;
    this.bundleSoldOut = false;
    var sl = this.state.slots[idx];
    this.state.prevStyle = this.state.style;
    this.state.style = sl.style;
    this.state.length = sl.length;
    this.render(false);
    this.announce(fill(this.cfg.strings.slotActive || 'Strip {n}', { n: idx + 1 }));
  };

  proto.bundleTotals = function () {
    var b = this.cfg.bundle;
    if (!b || !this.state.slots) return null;
    var prices = [], ok = true, items = {}, handles = {};
    for (var i = 0; i < this.state.slots.length; i++) {
      var sl = this.state.slots[i];
      var len = this.lengthOf(this.styleMap[sl.style], sl.length);
      if (!len || !len.insiderVariantId || !len.insiderAvailable) ok = false;
      if (len && len.insiderVariantId) {
        prices.push(len.insiderPrice || 0);
        items[len.insiderVariantId] = (items[len.insiderVariantId] || 0) + 1;
        if (!handles[len.insiderHandle]) handles[len.insiderHandle] = [];
        if (handles[len.insiderHandle].indexOf(len.insiderVariantId) < 0) handles[len.insiderHandle].push(len.insiderVariantId);
      }
    }
    var sorted = prices.slice().sort(function (a, b2) { return a - b2; });
    var free = 0;
    for (var f = 0; f < Math.min(b.free, sorted.length); f++) free += sorted[f];
    var total = prices.reduce(function (a, p) { return a + p; }, 0) - free;
    if (this.bundleSoldOut) ok = false; // 422 of pre-check: pas weer beschikbaar na een nieuwe keuze
    return { total: total, freeSum: free, perStrip: this.state.slots.length ? Math.round(total / this.state.slots.length) : 0, ok: ok && prices.length === this.state.slots.length, items: items, handles: handles };
  };

  proto.money = function (cents) {
    // zelfde notatie als Liquid `money` op deze winkel (€24,95); basis = priceFormatted van de huidige variant
    var ref = this.current().priceFormatted || '€0,00';
    var euro = (cents / 100).toFixed(2).replace('.', ',');
    var thousands = euro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return ref.indexOf('€') === 0 ? '€' + thousands : thousands + ' €';
  };

  proto.renderBundle = function (style, v) {
    var b = this.cfg.bundle;
    var box = this.querySelector('[data-slots]');
    if (!b) return;
    if (!box && !this.cfg.picker) return;
    var s = this.cfg.strings;
    var setPriceSingle = this.querySelector('[data-set-price="single"]');
    if (setPriceSingle) setPriceSingle.textContent = v.priceFormatted || '';
    if (this.state.set !== 'bundle') {
      var per0 = this.querySelector('.lc__price-per');
      if (per0 && this.perSingleText) per0.textContent = this.perSingleText;
    }
    var single5 = [];
    for (var k = 0; k < b.size; k++) single5.push({ style: this.state.style, length: this.state.length });
    var saved = this.state.slots;
    // prijs van de set-keuze: 5 × de huidige keuze (zoals de losse prijs ook de huidige keuze volgt)
    this.state.slots = this.state.set === 'bundle' && saved ? saved : single5;
    var t = this.bundleTotals();
    this.state.slots = saved;
    var setPriceBundle = this.querySelector('[data-set-price="bundle"]');
    if (setPriceBundle && t) setPriceBundle.textContent = this.money(t.total);
    if (this.state.set !== 'bundle' || !saved) return;
    var slots = box ? box.querySelectorAll('[data-slot]') : [];
    for (var i = 0; i < slots.length; i++) {
      var sl = saved[i];
      var st = sl ? this.styleMap[sl.style] : null;
      var on = i === this.state.activeSlot;
      slots[i].classList.toggle('is-active', on);
      slots[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      var txt = slots[i].querySelector('[data-slot-text]');
      if (txt && st) txt.textContent = st.title + ' · ' + sl.length + ' mm';
      var th = slots[i].querySelector('[data-slot-thumb]');
      if (th && st && st.thumb && th.getAttribute('src') !== st.thumb.src) th.src = st.thumb.src;
    }
    var act = saved[this.state.activeSlot];
    var actStyle = act ? this.styleMap[act.style] : null;
    this.text('[data-slot-active]', fill(s.slotActive || '', { n: this.state.activeSlot + 1 }) + (actStyle ? ': ' + actStyle.title + ' · ' + act.length + ' mm' : ''));
    if (t) {
      // prijsblok boven de box volgt de gekozen set (jury R2D): totaal + "5 strips · €12,99 per strip"
      this.text('[data-price-intro]', this.money(t.total));
      var per = this.querySelector('.lc__price-per');
      if (per) per.textContent = fill(s.introBundle || '{n} strips', { n: b.size, per: this.money(t.perStrip) });
      this.text('[data-bundle-per-strip]', fill(s.perStrip || '{price}', { price: this.money(t.perStrip) }));
      // leesbare samenvatting van de set: "3× Dane 12 mm · 1× Esmee 14 mm"
      var counts = {}, order = [];
      for (var q = 0; q < saved.length; q++) {
        var st2 = this.styleMap[saved[q].style];
        var key = (st2 ? st2.title : saved[q].style) + ' ' + saved[q].length + ' mm';
        if (!counts[key]) { counts[key] = 0; order.push(key); }
        counts[key]++;
      }
      var parts = [];
      for (var o = 0; o < order.length; o++) parts.push(counts[order[o]] + '× ' + order[o]);
      this.text('[data-bundle-summary]', fill(s.bundleSummary || 'Je set: {list}', { list: parts.join(' · ') }));
      this.text('[data-atc-price]', this.money(t.total));
      this.text('[data-sticky-price]', this.money(t.total));
      this.text('[data-sticky-summary]', fill(s.stickyBundle || '{n} strips', { n: b.size }));
      var buttons = this.querySelectorAll('[data-atc]');
      for (var j = 0; j < buttons.length; j++) {
        if (this.cfg.picker && (buttons[j].hasAttribute('data-picker-open') || buttons[j].hasAttribute('data-atc-single'))) continue; // R2G: opener en losse link hebben eigen labels/staten
        buttons[j].disabled = !t.ok;
        if (this.dataset.state !== 'added') this.setAtcLabel(buttons[j], t.ok ? (this.cfg.picker ? s.addToCart : fill(s.addBundle || 'Voeg {n} strips toe', { n: b.size })) : s.soldOut);
        var price = buttons[j].querySelector('[data-atc-price]');
        if (price) price.hidden = !t.ok;
      }
    }
    if (this.cfg.picker) this.renderPicker();
  };

  /* ---------- R2F: starter = 1 strip + toolkit (automatische korting op de toolkit; fail-closed, geen properties) ---------- */

  /* ---------- Starterkits (13-09-2026): Basic / Premium / Deluxe uit dezelfde producten ---------- */

  /* ---------- Wimperplan (abonnement, 14-09-2026) ----------
     Fail-closed: zonder plan voor de gekozen stijl/lengte, zonder gratis toolkit of zonder prijsvoordeel
     is er geen kaart en valt de keuze terug op los. */
  proto.plan = function () { return (this.cfg && this.cfg.wimperplan) || null; };

  proto.planSub = function () {
    var p = this.plan();
    if (!p || !p.enabled) return null;
    var v = this.current();
    return v && v.sub && v.sub.planId ? v.sub : null;
  };

  proto.planAvailable = function () { return !!this.planSub(); };

  proto.planTotals = function () {
    var p = this.plan();
    var sub = this.planSub();
    var v = this.current();
    if (!p || !sub || !v || typeof v.price !== 'number') return null;
    var qty = p.quantity || 1;
    var total = sub.unitPrice * qty;
    var loose = v.price * qty;
    return { total: total, compare: loose > total ? loose : null, unit: sub.unitPrice, quantity: qty };
  };

  proto.renderPlan = function () {
    var card = this.querySelector('[data-plan-card]');
    if (!card) return;
    var t = this.planTotals();
    var s = this.cfg.strings;
    if (!t) {
      card.hidden = true;
      if (this.state.set === 'wimperplan') this.setSet('single', true);
      return;
    }
    card.hidden = false;
    var pEl = this.querySelector('[data-set-price="wimperplan"]');
    if (pEl) pEl.textContent = this.money(t.total);
    var wEl = this.querySelector('[data-set-compare="wimperplan"]');
    if (wEl) { wEl.textContent = t.compare ? this.money(t.compare) : ''; wEl.hidden = !t.compare; }
    var oEl = this.querySelector('[data-set-off="wimperplan"]');
    if (oEl) {
      var pct = t.compare ? Math.floor((t.compare - t.total) * 100 / t.compare) : 0;
      oEl.textContent = pct > 0 ? '-' + pct + '%' : '';
      oEl.hidden = pct <= 0;
    }
    if (this.state.set !== 'wimperplan') return;
    this.text('[data-price-intro]', this.money(t.total));
    var per = this.querySelector('.lc__price-per');
    if (per) per.textContent = this.plan().sub || '';
    var cmp = this.querySelector('[data-price-compare]');
    if (cmp) { cmp.textContent = t.compare ? this.money(t.compare) : ''; cmp.hidden = !t.compare; }
    var off = this.querySelector('[data-price-off]');
    if (off) {
      var p2 = t.compare ? Math.floor((t.compare - t.total) * 100 / t.compare) : 0;
      off.textContent = p2 > 0 ? fill(s.saveBadge || 'Bespaar {n}%', { n: p2 }) : '';
      off.hidden = p2 <= 0;
    }
    this.text('[data-atc-price]', this.money(t.total));
    this.text('[data-sticky-price]', this.money(t.total));
    var style = this.currentStyle();
    this.text('[data-sticky-summary]', (this.plan().label || '') + ' · ' + style.title + ' · ' + this.state.length + ' mm');
    var cta = this.plan().cta;
    if (cta) {
      var lab = this.querySelector('[data-atc]:not([data-atc-sticky]) [data-atc-label]');
      if (lab) lab.textContent = cta;
    }
  };

  proto.addPlanToCart = function (btn) {
    var self = this;
    var sub = this.planSub();
    var p = this.plan();
    if (!sub || !p || btn.disabled || this.cartPending || this.dataset.state === 'busy') return;
    this.cartPending = true;
    var root = this.cfg.cartRoot || '/';
    this.setBusy(btn, true);
    this.hideError();
    var items = [{ id: sub.variantId, quantity: p.quantity || 1, selling_plan: sub.planId }];
    if (p.gift && p.gift.variantId) items.push({ id: p.gift.variantId, quantity: 1 });
    window.fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (r.status === 422 || (data && data.status === 422)) { self.setState('soldout'); self.showError(self.cfg.strings.soldOut); return null; }
        if (!r.ok) throw new Error(data && (data.description || data.message) || ('HTTP ' + r.status));
        return data;
      });
    }).then(function (data) {
      if (!data) return null;
      var s2 = self.cfg.strings;
      self.setState('added');
      var allBtns = self.querySelectorAll('[data-atc]');
      for (var bi = 0; bi < allBtns.length; bi++) self.setAtcLabel(allBtns[bi], s2.added);
      self.beacon('cfg_add_plan', { weeks: p.weeks, qty: p.quantity, variant: sub.variantId });
      self.openCart();
      clearTimeout(self.addedTimer);
      self.addedTimer = setTimeout(function () {
        if (self.dataset.state === 'added') { self.setState('idle'); self.render(false); }
      }, ADDED_MS);
    }).catch(function (err) {
      self.setState('error');
      self.showError(self.cfg.strings.error + (err && err.message ? ' (' + err.message + ')' : ''));
      self.beacon('cfg_add_error', { msg: String(err && err.message || '').slice(0, 80) });
    }).then(function () {
      self.cartPending = false;
      self.setBusy(btn, false);
    });
  };

  proto.kits = function () { return (this.cfg && this.cfg.kits) || []; };

  proto.kitByKey = function (key) {
    var ks = this.kits();
    for (var i = 0; i < ks.length; i++) if (ks[i].key === key) return ks[i];
    return null;
  };

  // De strips van een kit: strip 1 is de hoofdkeuze, strip 2 heeft een eigen lengte (zelfde stijl).
  proto.kitStrips = function (kit) {
    var first = this.current();
    var out = [first];
    if (!kit || kit.strips < 2) return out;
    var second = this.lengthOf(this.currentStyle(), this.state.length2 || this.state.length) || first;
    out.push(second);
    for (var i = 2; i < kit.strips; i++) out.push(first);
    return out;
  };

  proto.kitTotals = function (kit, v) {
    if (!kit || !v || typeof v.price !== 'number') return null;
    var strips = this.kitStrips(kit);
    var total = (kit.extrasPrice || 0) - (kit.off || 0);
    // giftsCompare: de winkelwaarde van de cadeaus en de verzending die bij deze kit gratis zijn (14-09, opdracht
    // Thomas). Telt alleen mee in de doorgestreepte prijs, nooit in wat de klant betaalt.
    var compare = (kit.extrasCompare || 0) + (kit.giftsCompare || 0);
    for (var i = 0; i < strips.length; i++) {
      var sp = typeof strips[i].price === 'number' ? strips[i].price : v.price;
      total += sp;
      compare += typeof strips[i].compareAt === 'number' && strips[i].compareAt > sp ? strips[i].compareAt : sp;
    }
    // 16-09: een vaste vanaf-prijs op de kit wint van de optelsom van de onderdelen
    if (kit.compareOverride > 0) compare = kit.compareOverride;
    return total > 0 ? { total: total, compare: compare > total ? compare : null } : null;
  };

  proto.renderKits = function (style, v) {
    var ks = this.kits();
    if (!ks.length) return;
    // de striptegels in de kitkaarten volgen de gekozen stijl en tonen de strip zelf, nooit de close-up van het oog
    var src = (style && style.strip && style.strip.src) || '';
    var strips = this.querySelectorAll('[data-kit-strip]');
    for (var si = 0; si < strips.length; si++) {
      if (src) { if (strips[si].getAttribute('src') !== src) strips[si].src = src; strips[si].hidden = false; }
      else { strips[si].hidden = true; strips[si].removeAttribute('src'); }
    }
    var s = this.cfg.strings;
    var active = null;
    for (var i = 0; i < ks.length; i++) {
      var kit = ks[i];
      var t = this.kitTotals(kit, v);
      var pEl = this.querySelector('[data-set-price="' + kit.key + '"]');
      var cEl = this.querySelector('[data-set-compare="' + kit.key + '"]');
      if (pEl) pEl.textContent = t ? this.money(t.total) : '';
      if (cEl) { cEl.textContent = t && t.compare ? this.money(t.compare) : ''; cEl.hidden = !(t && t.compare); }
      var oEl = this.querySelector('[data-set-off="' + kit.key + '"]');
      if (oEl) {
        var pct = t && t.compare ? Math.floor((t.compare - t.total) * 100 / t.compare) : 0;
        oEl.textContent = pct > 0 ? '-' + pct + '%' : '';
        oEl.hidden = !(kit.showCompare && pct > 0);
      }
      if (kit.key === this.state.set) active = { kit: kit, t: t };
    }
    var single = this.querySelector('[data-set-price="single"]');
    if (single) single.textContent = v.priceFormatted || '';
    if (!this.kitByKey(this.state.set)) {
      var off0 = this.querySelector('[data-price-off]'); if (off0) { off0.textContent = ''; off0.hidden = true; }
      var cmp0 = this.querySelector('[data-price-compare]'); if (cmp0) { cmp0.textContent = ''; cmp0.hidden = true; }
    }
    // tweede lengte alleen bij een kit met 2 of meer strips
    var kitNow = this.kitByKey(this.state.set);
    var twee = !!(kitNow && kitNow.strips >= 2);
    // 15-09: de hint onder de stijlen ("Twijfel je? ...") beweegt mee: bij 2 strips de tweede tekst, anders de eerste
    var hint = this.querySelector('[data-rail-hint]');
    if (hint) {
      var h1 = hint.getAttribute('data-hint-one') || '', h2 = hint.getAttribute('data-hint-two') || '';
      var ht = twee && h2 ? h2 : (h1 || h2);
      if (hint.textContent !== ht) hint.textContent = ht;
      hint.hidden = !ht;
    }
    var g2 = this.querySelector('[data-length-group="2"]');
    if (g2) { g2.hidden = !twee; if (twee) g2.removeAttribute('inert'); else g2.setAttribute('inert', ''); }
    var leg = this.querySelector('[data-length-legend]');
    if (leg) leg.textContent = twee ? (leg.getAttribute('data-legend-two') || leg.textContent) : (leg.getAttribute('data-legend-one') || leg.textContent);
    if (twee) {
      if (!this.state.length2) this.state.length2 = this.state.length;
      var l2 = this.lengthOf(style, this.state.length2);
      if (!l2 || !l2.available) { this.state.length2 = this.state.length; }
      var r2 = this.querySelector('input[data-length2][value="' + this.state.length2 + '"]');
      if (r2 && !r2.checked) r2.checked = true;
      var in2 = this.querySelectorAll('input[data-length2]');
      for (var q = 0; q < in2.length; q++) {
        var len2 = this.lengthOf(style, in2[q].value);
        var ok2 = !!(len2 && len2.available);
        in2[q].disabled = !ok2;
        var lab2 = this.querySelector('[data-length2-label="' + in2[q].value + '"]');
        if (lab2) { lab2.classList.toggle('is-unavailable', !ok2); var st2 = lab2.querySelector('[data-pill-state]'); if (st2) st2.textContent = ok2 ? '' : (s.soldOut || ''); }
      }
    }
    if (!active || !active.t) return;
    this.text('[data-price-intro]', this.money(active.t.total));
    var per = this.querySelector('.lc__price-per');
    if (per) per.textContent = active.kit.sub || '';
    var off = this.querySelector('[data-price-off]');
    var pct = active.t.compare ? Math.floor((active.t.compare - active.t.total) * 100 / active.t.compare) : 0;
    var wil = !!(active.kit.showCompare && pct > 0);
    if (off) {
      off.textContent = wil ? fill(s.saveBadge || 'Bespaar {n}%', { n: pct }) : '';
      off.hidden = !wil;
    }
    // dezelfde doorgestreepte winkelsom als op de kitkaart, ook naast de prijs bovenaan
    var cmp = this.querySelector('[data-price-compare]');
    if (cmp) {
      var toon = !!(active.kit.showCompare && active.t.compare > active.t.total);
      cmp.textContent = toon ? this.money(active.t.compare) : '';
      cmp.hidden = !toon;
    }
    this.text('[data-atc-price]', this.money(active.t.total));
    this.text('[data-sticky-price]', this.money(active.t.total));
    this.text('[data-sticky-summary]', (active.kit.label || '') + ' · ' + style.title + ' · ' + this.state.length + ' mm');
  };

  proto.addKitToCart = function (btn, kit) {
    var self = this;
    var v = this.current();
    var style = this.currentStyle();
    var s = this.cfg.strings;
    var t = this.kitTotals(kit, v);
    if (!t || !v.variantId || !v.available || btn.disabled || this.cartPending || this.dataset.state === 'busy') return;
    this.cartPending = true;
    var root = this.cfg.cartRoot || '/';
    this.setBusy(btn, true);
    this.hideError();
    var check = function (handle, id) {
      return window.fetch(root + 'products/' + handle + '.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !Array.isArray(p.variants)) throw new Error();
          for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i].available === true;
          throw new Error();
        });
    };
    var strips = this.kitStrips(kit);
    var seenOrig = {};
    var checks = [];
    for (var sv2 = 0; sv2 < strips.length; sv2++) {
      var k2 = strips[sv2].originalHandle + '|' + strips[sv2].originalVariantId;
      if (seenOrig[k2]) continue;
      seenOrig[k2] = true;
      checks.push(check(strips[sv2].originalHandle, strips[sv2].originalVariantId));
    }
    var nStrip = checks.length;
    for (var e = 0; e < kit.extras.length; e++) checks.push(check(kit.extras[e].handle, kit.extras[e].variantId));
    // 15-09 (opdracht Thomas): de gratis cadeaus (schaartje, borsteltje) gaan als echte regels mee: aparte producten
    // van 0,00 met dezelfde SKU's (zie scripts/create_gift_products.py), want een koop-X-krijg-Y-korting werkt niet
    // naast de kitkortingen. Een cadeau dat niet beschikbaar is houdt de kit niet tegen, het valt dan stilletjes weg.
    var nBase = checks.length;
    var gifts = kit.gifts || [];
    for (var g = 0; g < gifts.length; g++) checks.push(check(gifts[g].handle, gifts[g].variantId).then(function (ok) { return ok; }, function () { return false; }));
    Promise.all(checks).then(function (oks) {
      if (oks.slice(0, nStrip).indexOf(false) >= 0) { self.markSoldOut(style, v); return null; }
      if (oks.slice(0, nBase).indexOf(false) >= 0) { self.kitSoldOut = true; self.setState('soldout'); self.showError(s.soldOut); return null; }
      var giftOk = oks.slice(nBase);
      var byId = {}, order = [];
      for (var si = 0; si < strips.length; si++) {
        var id = strips[si].variantId;
        if (!byId[id]) { byId[id] = 0; order.push(id); }
        byId[id] += 1;
      }
      // opdracht Thomas 14-09: in de winkelwagen moet zichtbaar zijn WELKE starterkit is toegevoegd en met welke
      // keuze. De regels zelf zijn losse producten (strips + toolkit), dus zonder deze eigenschap ziet de klant
      // alleen losse onderdelen. De eigenschap staat op elke regel van de kit, zodat ze bij elkaar horen.
      var mmLijst = [];
      for (var mi = 0; mi < strips.length; mi++) {
        var mm = String(strips[mi].mm || '');
        if (mm) mmLijst.push(mm);
      }
      var eig = {};
      if (kit.label) eig['Starterkit'] = kit.label;
      if (style && style.title) eig['Jouw look'] = style.title + (mmLijst.length ? ' \u00b7 ' + mmLijst.join(' + ') + ' mm' : '');
      // 16-09 (opdracht Thomas): verborgen eigenschap (underscore = niet zichtbaar voor de klant)
      // zodat de winkelwagen kan tonen wat er in de kit zit zonder de losse regels te laten zien.
      var inhoud = [];
      inhoud.push(strips.length + 'x lash strip' + (strips.length === 1 ? '' : 's'));
      for (var xi = 0; xi < kit.extras.length; xi++) {
        var xt = kit.extras[xi].title || '';
        inhoud.push('1x ' + (xt.split(' - ')[0].split(' | ')[0] || xt).trim());
      }
      if (inhoud.length) eig['_Inhoud'] = inhoud.join(' \u00b7 ');
      // 16-09 (opdracht Thomas): de foto van de kit zelf mee, anders staat in de winkelwagen
      // de stripfoto en ziet een Deluxe er hetzelfde uit als een Basic.
      if (kit.hero && kit.hero.src) eig['_Foto'] = kit.hero.src;
      var items = order.map(function (id) { return { id: parseInt(id, 10), quantity: byId[id], properties: eig }; });
      for (var i = 0; i < kit.extras.length; i++) {
        // gratis verzending staat als eigenschap op de eerste extra (de toolkit), zodat het een keer in de winkelwagen staat
        var xeig = eig;
        if (i === 0 && kit.freeShipping) { xeig = {}; for (var xk in eig) xeig[xk] = eig[xk]; xeig['Verzending'] = 'Gratis'; }
        items.push({ id: kit.extras[i].variantId, quantity: 1, properties: xeig });
      }
      for (var gi = 0; gi < gifts.length; gi++) {
        if (giftOk[gi] === false) continue;
        var geig = {};
        if (kit.label) geig['Starterkit'] = kit.label;
        items.push({ id: gifts[gi].variantId, quantity: 1, properties: geig });
      }
      return window.fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (r.status === 422 || (data && data.status === 422)) { self.kitSoldOut = true; self.setState('soldout'); self.showError(s.soldOut); return null; }
          if (!r.ok) throw new Error(data && (data.description || data.message) || ('HTTP ' + r.status));
          return data;
        });
      }).then(function (data) {
        if (!data) return null;
        self.setState('added');
        var allBtns = self.querySelectorAll('[data-atc]');
        for (var bi = 0; bi < allBtns.length; bi++) self.setAtcLabel(allBtns[bi], s.added);
        self.announce(fill(s.liveAdded, { style: style.title, mm: self.state.length }));
        self.beacon('cfg_add_kit', { kit: kit.key, style: style.key, length: self.state.length, variant: v.variantId });
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lash-configurator', productVariantId: v.variantId, cartData: data }); } catch (e2) {}
        }
        self.openCart();
        clearTimeout(self.addedTimer);
        self.addedTimer = setTimeout(function () {
          if (self.dataset.state === 'added') { self.setState('idle'); self.render(false); }
        }, ADDED_MS);
      });
    }).catch(function (err) {
      self.setState('error');
      self.showError(s.error + (err && err.message ? ' (' + err.message + ')' : ''));
      self.beacon('cfg_add_error', { msg: String(err && err.message || '').slice(0, 80) });
    }).then(function () {
      self.cartPending = false;
      self.setBusy(btn, false);
    });
  };

  proto.starterTotal = function (v) {
    var st = this.cfg.starter;
    if (!st || !st.toolkit || !v || typeof v.price !== 'number') return null;
    var total = v.price + st.toolkit.price - st.off;
    return total > 0 ? total : null;
  };

  proto.renderStarter = function (style, v) {
    var st = this.cfg.starter;
    if (!st) return;
    var s = this.cfg.strings;
    var total = this.starterTotal(v);
    var card = this.querySelector('[data-set-price="starter"]');
    if (card) card.textContent = total !== null ? this.money(total) : '';
    if (this.state.set !== 'starter') return;
    if (total === null) return;
    this.text('[data-price-intro]', this.money(total));
    var per = this.querySelector('.lc__price-per');
    if (per) per.textContent = s.starterIntro || '1 strip + toolkit';
    this.text('[data-atc-price]', this.money(total));
    this.text('[data-sticky-price]', this.money(total));
    this.text('[data-sticky-summary]', fill(s.stickyStarter || 'Starter · {look}', { look: style.title + ' · ' + this.state.length + ' mm' }));
  };

  proto.addStarterToCart = function (btn) {
    var self = this;
    var v = this.current();
    var style = this.currentStyle();
    var s = this.cfg.strings;
    var st = this.cfg.starter;
    var tk = st && st.toolkit;
    if (!tk || !v.variantId || !v.available || btn.disabled || this.cartPending || this.dataset.state === 'busy') return;
    this.cartPending = true;
    var root = this.cfg.cartRoot || '/';
    this.setBusy(btn, true);
    this.hideError();
    var check = function (handle, id) {
      return window.fetch(root + 'products/' + handle + '.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !Array.isArray(p.variants)) throw new Error();
          for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i].available === true;
          throw new Error();
        });
    };
    Promise.all([check(v.originalHandle, v.originalVariantId), check(tk.handle, tk.variantId)]).then(function (oks) {
      if (oks[0] === false) { self.markSoldOut(style, v); return null; }
      if (oks[1] === false) { self.starterSoldOut = true; self.setState('soldout'); self.showError(s.soldOut); return null; }
      var items = [{ id: v.variantId, quantity: 1 }, { id: tk.variantId, quantity: 1 }];
      return window.fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (r.status === 422 || (data && data.status === 422)) { self.starterSoldOut = true; self.setState('soldout'); self.showError(s.soldOut); return null; }
          if (!r.ok) throw new Error(data && (data.description || data.message) || ('HTTP ' + r.status));
          return data;
        });
      }).then(function (data) {
        if (!data) return null;
        self.setState('added');
        var allBtns = self.querySelectorAll('[data-atc]');
        for (var bi = 0; bi < allBtns.length; bi++) self.setAtcLabel(allBtns[bi], s.added);
        self.announce(fill(s.liveAdded, { style: style.title, mm: self.state.length }));
        self.beacon('cfg_add_starter', { style: style.key, length: self.state.length, variant: v.variantId, toolkit: tk.variantId });
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lash-configurator', productVariantId: v.variantId, cartData: data }); } catch (e) {}
        }
        self.openCart();
        clearTimeout(self.addedTimer);
        self.addedTimer = setTimeout(function () {
          if (self.dataset.state === 'added') { self.setState('idle'); self.render(false); }
        }, ADDED_MS);
        // korting op de toolkit toegepast? (geen stille overcharge; niets wordt automatisch verwijderd)
        return window.fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
          if (!cart || !cart.items) return;
          var disc = 0;
          for (var ci = 0; ci < cart.items.length; ci++) if (String(cart.items[ci].variant_id) === String(tk.variantId)) disc += cart.items[ci].line_level_total_discount || 0;
          if (disc < st.off) self.showError(s.starterNotApplied || 'Korting niet toegepast');
        }).catch(function () {});
      });
    }).catch(function (err) {
      self.setState('error');
      self.showError(s.error + (err && err.message ? ' (' + err.message + ')' : ''));
      self.beacon('cfg_add_error', { msg: String(err && err.message || '').slice(0, 80) });
    }).then(function () {
      self.cartPending = false;
      self.setBusy(btn, false);
      if (self.dataset.state !== 'added') self.renderStarter(self.currentStyle(), self.current());
    });
  };

  /* ---------- R2G: keuzescherm "Kies je stijlen" (voorbeeld: sk-drawer) ---------- */

  proto.setupPicker = function () {
    var self = this;
    var root = this.querySelector('[data-picker]');
    if (!root) return;
    this.pickerRoot = root;
    this.pickerOpen = false;
    this.pickerStep = 1;
    this.pickerLength = this.state.length;
    root.addEventListener('click', function (e) {
      var t = e.target;
      var el;
      if ((el = t.closest('[data-picker-close]'))) { self.closePicker(); return; }
      if ((el = t.closest('[data-picker-goto]'))) { self.pickerGoto(parseInt(el.getAttribute('data-picker-goto'), 10)); return; }
      if ((el = t.closest('[data-picker-mm]'))) { self.pickerSetLength(el.getAttribute('data-picker-mm')); return; }
      if ((el = t.closest('[data-picker-plus]'))) { self.pickerAdd(el.getAttribute('data-picker-plus')); return; }
      if ((el = t.closest('[data-picker-add]'))) { self.pickerAdd(el.getAttribute('data-picker-add')); return; }
      if ((el = t.closest('[data-picker-minus]'))) { self.pickerRemove(el.getAttribute('data-picker-minus')); return; }
      if ((el = t.closest('[data-picker-swap]'))) { self.pickerSwap(parseInt(el.getAttribute('data-picker-swap'), 10) - 1); return; }
      if ((el = t.closest('[data-picker-slot]'))) { self.pickerSlotTap(parseInt(el.getAttribute('data-picker-slot'), 10) - 1); return; }
      if ((el = t.closest('[data-atc-picker]'))) { self.addBundleToCart(el); return; }
    }, { signal: this.ac.signal });
    root.addEventListener('keydown', function (e) {
      if (!self.pickerOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closePicker(); return; }
      if (e.key === 'Tab') {
        var f = self.pickerFocusables();
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    }, { signal: this.ac.signal });
    this.renderPicker();
  };

  proto.pickerFocusables = function () {
    var stage = this.pickerRoot.querySelector('[data-picker-step].is-active');
    if (!stage) return [];
    var list = stage.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null || list[i] === document.activeElement) out.push(list[i]);
    return out;
  };

  proto.openPicker = function (opener) {
    if (!this.pickerRoot || this.pickerOpen) return;
    this.pickerOpener = opener || null;
    this.pickerOpen = true;
    if (this.storyOpen) this.closeStory();
    this.pickerRoot.hidden = false;
    this.pickerRoot.removeAttribute('inert');
    document.documentElement.classList.add('lc--picker-open');
    var complete = this.picks.length >= this.cfg.picker.slots;
    this.pickerGoto(complete ? 2 : 1);
    this.beacon('cfg_picker_open', { picks: this.picks.length });
    var bar = this.querySelector('[data-sticky]');
    if (bar) this.updateSticky(bar);
    this.guardChat(false);
  };

  proto.closePicker = function () {
    if (!this.pickerRoot || !this.pickerOpen) return;
    this.pickerOpen = false;
    this.pickerRoot.hidden = true;
    this.pickerRoot.setAttribute('inert', '');
    document.documentElement.classList.remove('lc--picker-open');
    var op = this.pickerOpener;
    this.pickerOpener = null;
    if (op && typeof op.focus === 'function') { try { op.focus(); } catch (e) {} }
    var bar = this.querySelector('[data-sticky]');
    if (bar) this.updateSticky(bar);
    this.guardChat(false);
  };

  proto.pickerGoto = function (n) {
    var stages = this.pickerRoot.querySelectorAll('[data-picker-step]');
    for (var i = 0; i < stages.length; i++) {
      var on = parseInt(stages[i].getAttribute('data-picker-step'), 10) === n;
      stages[i].classList.toggle('is-active', on);
      stages[i].hidden = !on;
    }
    this.pickerStep = n;
    this.renderPicker();
    var stage = this.pickerRoot.querySelector('[data-picker-step="' + n + '"]');
    var first = stage && stage.querySelector('h2');
    if (first) { first.setAttribute('tabindex', '-1'); try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  };

  proto.pickerSetLength = function (mm) {
    this.pickerLength = String(mm);
    this.renderPicker();
  };

  proto.pickerAdd = function (key) {
    var b = this.cfg.picker;
    if (!b || !this.styleMap[key]) return;
    var len = this.lengthOf(this.styleMap[key], this.pickerLength);
    if (!len || !len.insiderAvailable) { this.announce(this.cfg.strings.soldOut); return; }
    var pick = { style: key, length: this.pickerLength };
    if (this.pickerTarget !== null && this.picks[this.pickerTarget] !== undefined) { this.picks[this.pickerTarget] = pick; this.pickerTarget = null; }
    else if (this.picks.length < b.slots) this.picks.push(pick);
    else return;
    this.pickerCommit();
    this.announce(fill(this.cfg.strings.pickerOf || 'Strip {n} van {total}', { n: this.picks.length, total: b.slots }) + ': ' + this.styleMap[key].title + ' · ' + this.pickerLength + ' mm');
    if (this.picks.length >= b.slots) { var self = this; setTimeout(function () { if (self.pickerOpen && self.picks.length >= b.slots) self.pickerGoto(2); }, 350); }
    else this.renderPicker();
  };

  proto.pickerRemove = function (key) {
    for (var i = this.picks.length - 1; i >= 0; i--) {
      if (this.picks[i].style === key) { this.picks.splice(i, 1); break; }
    }
    this.pickerTarget = null;
    this.pickerCommit();
    this.renderPicker();
  };

  proto.pickerSwap = function (idx) {
    if (!this.picks[idx]) return;
    this.pickerTarget = idx;
    this.pickerLength = this.picks[idx].length;
    this.pickerGoto(1);
  };

  proto.pickerSlotTap = function (idx) {
    if (this.picks[idx]) { this.pickerTarget = idx; this.pickerLength = this.picks[idx].length; this.renderPicker(); }
  };

  // de gekozen strips worden de bundel-slots (prijzen, payload); onvolledig: aangevuld met de huidige look voor de prijsweergave
  proto.pickerCommit = function () {
    var b = this.cfg.picker;
    var slots = this.picks.slice(0, b.slots);
    while (slots.length < b.slots) slots.push({ style: this.state.style, length: this.state.length });
    this.state.slots = slots;
    this.state.activeSlot = 0;
    this.bundleSoldOut = false;
    this.render(false);
  };

  proto.pickerSavings = function (t) {
    var sv = this.cfg.picker && this.cfg.picker.savings;
    if (!sv || !t || !sv.salonYear || !sv.wearDays) return null;
    var perYear = Math.round((365 / sv.wearDays) * (t.perStrip / 100));
    var saving = Math.round(sv.salonYear - perYear);
    return saving > 0 ? saving : null;
  };

  proto.renderPicker = function () {
    var root = this.pickerRoot;
    var b = this.cfg.picker;
    if (!root || !b) return;
    var s = this.cfg.strings;
    var n = this.picks.length;
    var nextIdx = this.pickerTarget !== null ? this.pickerTarget : n;
    // vakjes
    var slots = root.querySelectorAll('[data-picker-slot]');
    for (var i = 0; i < slots.length; i++) {
      var p = this.picks[i];
      var st = p ? this.styleMap[p.style] : null;
      var img = slots[i].querySelector('[data-picker-slot-img]');
      var mm = slots[i].querySelector('[data-picker-slot-mm]');
      slots[i].classList.toggle('is-filled', !!p);
      slots[i].classList.toggle('is-next', !p && i === nextIdx || (this.pickerTarget === i));
      if (img) { if (st && st.thumb) { if (img.getAttribute('src') !== st.thumb.src) img.src = st.thumb.src; img.hidden = false; } else { img.hidden = true; img.removeAttribute('src'); } }
      if (mm) mm.textContent = p ? p.length : '';
      slots[i].setAttribute('aria-label', p ? (fill(s.slot || 'Strip {n}', { n: i + 1 }) + ': ' + (st ? st.title : p.style) + ' · ' + p.length + ' mm') : fill(s.pickerSlotEmpty || 'Strip {n}: nog leeg', { n: i + 1 }));
    }
    // lengte-pills
    var mms = root.querySelectorAll('[data-picker-mm]');
    for (var m = 0; m < mms.length; m++) { var on = mms[m].getAttribute('data-picker-mm') === String(this.pickerLength); mms[m].classList.toggle('is-active', on); mms[m].setAttribute('aria-pressed', on ? 'true' : 'false'); }
    // kaarten: aantal per stijl, beschikbaarheid/voorraad voor de gekozen lengte
    var counts = {};
    for (var c = 0; c < this.picks.length; c++) counts[this.picks[c].style] = (counts[this.picks[c].style] || 0) + 1;
    var cards = root.querySelectorAll('[data-picker-card]');
    var full = n >= b.slots && this.pickerTarget === null;
    for (var k = 0; k < cards.length; k++) {
      var key = cards[k].getAttribute('data-picker-card');
      var cnt = counts[key] || 0;
      var len = this.lengthOf(this.styleMap[key], this.pickerLength);
      var ok = !!(len && len.insiderAvailable);
      cards[k].classList.toggle('has-count', cnt > 0);
      cards[k].classList.toggle('is-selected', cnt > 0);
      cards[k].classList.toggle('is-unavailable', !ok);
      var badge = cards[k].querySelector('[data-picker-badge]');
      if (badge) badge.hidden = !(len && len.lowStock && ok);
      var cEl = cards[k].querySelector('[data-picker-count]');
      if (cEl) cEl.textContent = String(cnt);
      var add = cards[k].querySelector('[data-picker-add]');
      if (add) add.disabled = !ok || full;
      var plus = cards[k].querySelector('[data-picker-plus]');
      if (plus) plus.disabled = !ok || full;
      var stepper = cards[k].querySelector('[data-picker-stepper]');
      if (stepper) stepper.hidden = cnt === 0;
    }
    // stap 2: tegels, besparing, knop
    var tiles = root.querySelectorAll('[data-picker-tile]');
    for (var ti = 0; ti < tiles.length; ti++) {
      var pk = this.picks[ti];
      var st2 = pk ? this.styleMap[pk.style] : null;
      var timg = tiles[ti].querySelector('[data-picker-tile-img]');
      var tmm = tiles[ti].querySelector('[data-picker-tile-mm]');
      tiles[ti].hidden = !pk;
      if (timg && st2 && st2.preview) { if (timg.getAttribute('src') !== st2.preview.src) timg.src = st2.preview.src; timg.alt = st2.title + ' · ' + pk.length + ' mm'; }
      if (tmm) tmm.textContent = pk ? pk.length + ' mm' : '';
    }
    var t = this.bundleTotals();
    if (t) {
      var looseSum = 0;
      for (var q = 0; q < this.state.slots.length; q++) { var L = this.lengthOf(this.styleMap[this.state.slots[q].style], this.state.slots[q].length); looseSum += (L && typeof L.price === 'number') ? L.price : 0; }
      this.text('[data-picker-save]', looseSum > t.total ? this.money(looseSum - t.total) : '');
      var sav = this.pickerSavings(t);
      var savBox = root.querySelector('[data-picker-savings]');
      if (savBox) { savBox.hidden = sav === null; var amt = savBox.querySelector('[data-picker-savings-amount]'); if (amt && sav !== null) amt.textContent = this.money(sav * 100); }
      // copy op survey-data (12-09): prijs per strip en per dag (perStrip / draagdagen, afgerond op 10 cent), alleen met tekst + draagdagen
      var pd = root.querySelector('[data-picker-perday]');
      if (pd) {
        var wd = b.wearDays || 0;
        if (t && b.perDayText && wd > 0) {
          var dayCents = Math.round(t.perStrip / wd / 10) * 10;
          pd.textContent = fill(b.perDayText, { total: this.money(t.total), n: b.slots, strip: this.money(t.perStrip), day: this.money(dayCents) });
          pd.hidden = false;
        } else pd.hidden = true;
      }
      var pb = root.querySelector('[data-atc-picker]');
      if (pb) { pb.disabled = !(t.ok && n >= b.slots); var pp = pb.querySelector('[data-atc-price]'); if (pp) pp.textContent = this.money(t.total); }
    }
  };

  proto.addBundleToCart = function (btn) {
    var self = this;
    var s = this.cfg.strings;
    var t = this.bundleTotals();
    if (!t || !t.ok || btn.disabled || this.cartPending || this.dataset.state === 'busy') return;
    this.cartPending = true;
    var root = this.cfg.cartRoot || '/';
    this.setBusy(btn, true);
    this.hideError();
    var handles = Object.keys(t.handles);
    var checks = handles.map(function (h) {
      return window.fetch(root + 'products/' + h + '.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !Array.isArray(p.variants)) throw new Error();
          return t.handles[h].every(function (id) {
            for (var i = 0; i < p.variants.length; i++) {
              if (String(p.variants[i].id) === String(id)) return p.variants[i].available === true;
            }
            throw new Error();
          });
        });
    });
    Promise.all(checks).then(function (oks) {
      if (oks.indexOf(false) >= 0) { self.bundleSoldOut = true; self.setState('soldout'); self.showError(s.soldOut); return null; }
      var items = [];
      for (var id in t.items) if (Object.prototype.hasOwnProperty.call(t.items, id)) items.push({ id: parseInt(id, 10), quantity: t.items[id] });
      return window.fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (r.status === 422 || (data && data.status === 422)) { self.bundleSoldOut = true; self.setState('soldout'); self.showError(s.soldOut); return null; }
          if (!r.ok) throw new Error(data && (data.description || data.message) || ('HTTP ' + r.status));
          return data;
        });
      }).then(function (data) {
        if (!data) return null;
        self.setState('added');
        var allBtns = self.querySelectorAll('[data-atc]');
        for (var bi = 0; bi < allBtns.length; bi++) self.setAtcLabel(allBtns[bi], s.added);
        self.announce(s.added);
        self.beacon('cfg_add_bundle', { items: items.length, total: t.total });
        if (self.pickerOpen) self.closePicker();
        self.openCart();
        clearTimeout(self.addedTimer);
        self.addedTimer = setTimeout(function () {
          if (self.dataset.state === 'added') { self.setState('idle'); self.render(false); }
        }, ADDED_MS);
        // korting toegepast? (geen stille overcharge; niets wordt automatisch verwijderd)
        return window.fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
          if (!cart || !cart.items) return;
          var disc = 0;
          for (var ci = 0; ci < cart.items.length; ci++) {
            var it = cart.items[ci];
            if (t.items[it.variant_id]) disc += it.line_level_total_discount || 0;
          }
          // verwacht: de 2 goedkoopste van de 5 gratis (= freeSum); minder = de automatische korting is niet (meer) toegepast
          if (disc < t.freeSum) self.showError(s.bundleNotApplied || 'Korting niet toegepast');
        }).catch(function () {});
      });
    }).catch(function (err) {
      self.setState('error');
      self.showError(s.error + (err && err.message ? ' (' + err.message + ')' : ''));
    }).then(function () {
      self.cartPending = false;
      self.setBusy(btn, false);
      // labels/prijzen van de bundelstand herstellen zonder de fout-/uitverkochtstaat te overschrijven (render() zou die resetten)
      if (self.dataset.state !== 'added') self.renderBundle(self.currentStyle(), self.current());
    });
  };

  proto.lengthByInsider = function (id) {
    for (var i = 0; i < this.styles.length; i++) {
      for (var j = 0; j < this.styles[i].lengths.length; j++) {
        if (String(this.styles[i].lengths[j].insiderVariantId) === String(id)) return this.styles[i].lengths[j];
      }
    }
    return null;
  };

  proto.markSoldOut = function (style, v) {
    v.available = false;
    this.setState('soldout');
    this.render(false);
    this.announce(fill(this.cfg.strings.liveSoldOut, { style: style.title, mm: this.state.length }));
  };

  proto.setAtcLabel = function (btn, txt) {
    var label = btn.querySelector('[data-atc-label]');
    if (label) label.textContent = txt; else btn.textContent = txt;
  };

  proto.setBusy = function (btn, busy) {
    if (busy) {
      this.setState('busy');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('loading');
      var sp = btn.querySelector('.loading__spinner');
      if (sp) sp.classList.remove('hidden');
      this.setAtcLabel(btn, this.cfg.strings.adding);
    } else {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
      var sp2 = btn.querySelector('.loading__spinner');
      if (sp2) sp2.classList.add('hidden');
      if (this.dataset.state === 'busy') this.setState('idle');
      if (this.dataset.state !== 'added') this.setAtcAvailability(!!this.current().available, this.currentStyle());
    }
  };

  proto.showError = function (msg) {
    var pe = this.querySelector('[data-error-picker]');
    if (pe) { pe.textContent = msg; pe.hidden = !this.pickerOpen; }
    var el = this.querySelector('[data-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) {}
  };

  proto.hideError = function () {
    var pe = this.querySelector('[data-error-picker]');
    if (pe) { pe.hidden = true; pe.textContent = ''; }
    var el = this.querySelector('[data-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  };

  proto.openCart = function () {
    var root = this.cfg.cartRoot || '/';
    setTimeout(function () {
      var kc = window.kachingCartApi;
      var drawer = document.querySelector('#kaching-cart');
      if (kc && typeof kc.openCart === 'function') {
        if (!drawer || !drawer.offsetHeight) {
          try { if (typeof kc.refreshCart === 'function') kc.refreshCart(); kc.openCart(); } catch (e) {}
        }
        return;
      }
      var dawn = document.querySelector('cart-drawer');
      if (!dawn || typeof dawn.renderContents !== 'function') return;
      window.fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (sections && /id="CartDrawer"/.test(sections['cart-drawer'] || '')) dawn.renderContents({ sections: sections });
        }).catch(function () {});
    }, CART_OPEN_DELAY_MS);
  };

  /* ---------- sticky ---------- */

  proto.setupSticky = function () {
    var self = this;
    var bar = this.querySelector('[data-sticky]');
    var atc = this.querySelector('[data-atc]:not([data-atc-sticky])');
    if (!bar || !atc || !this.cfg.stickyCta || !('IntersectionObserver' in window)) return;
    this.stickyAtcVisible = true;
    this.stickyNearSection = true;
    var update = function () { self.updateSticky(bar); };
    this.ioAtc = new IntersectionObserver(function (entries) {
      var e = entries[0];
      self.stickyAtcAbove = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      self.stickyAtcVisible = e.isIntersecting;
      update();
    }, { threshold: 0 });
    this.ioAtc.observe(atc);
    // opdracht Thomas 14-09: de balk verdween zodra je meer dan 600 px voorbij de configurator scrolde. Nu blijft hij
    // staan zolang de sectie is begonnen, dus de hele pagina door tot en met de FAQ en de galerij. De bovenmarge van
    // de root rekt het meetvlak omhoog, zodat de sectie ook 'in beeld' blijft tellen als je er allang voorbij bent.
    this.ioSection = new IntersectionObserver(function (entries) {
      self.stickyNearSection = entries[0].isIntersecting;
      update();
    }, { rootMargin: '100000px 0px 0px 0px', threshold: 0 });
    this.ioSection.observe(this);
    var kc = document.querySelector('#kaching-cart');
    if (kc && 'MutationObserver' in window) {
      this.moCart = new MutationObserver(update);
      this.moCart.observe(kc, { attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });
    }
    window.addEventListener('resize', update, { passive: true, signal: this.ac.signal });
    // scroll-listener (throttled) naast de IntersectionObservers: een programmatische sprong (scrollTo) levert
    // niet altijd tijdig een IO-callback op; de rect-meting is deterministisch.
    var ticking = false;
    var measure = function () {
      ticking = false;
      var r = atc.getBoundingClientRect();
      var sr = self.getBoundingClientRect();
      self.stickyAtcAbove = r.bottom < 0;
      self.stickyAtcVisible = r.bottom > 0 && r.top < window.innerHeight;
      self.stickyNearSection = sr.top < window.innerHeight; // zie ioSection: alleen nog 'de sectie is begonnen'
      update();
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(measure);
    }, { passive: true, signal: this.ac.signal });
    measure();
  };

  // Een "vreemde bottom bar" is een fixed element dat onderaan de viewport zit, minstens 40 px hoog en hoogstens de
  // halve viewport (drawers, overlays en de Kaching-cart-container zijn schermvullend en tellen niet), zichtbaar
  // (geen opacity 0 / pointer-events none) en breder dan de halve viewporthoogte. De eigen chat-bubble en de
  // Shopify preview-balk (alleen in previews aanwezig) tellen nooit mee.
  proto.foreignBottomBar = function () {
    var els = document.querySelectorAll('body *');
    var vh = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === this || this.contains(el) || el.id === 'lashthing-chat-frame') continue;
      if (el.id === 'PBarNextFrameWrapper' || el.id === 'preview-bar-iframe' || (el.id && /preview-bar|PBar/i.test(el.id))) continue;
      if (el.offsetHeight < 40) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (cs.opacity === '0' || cs.pointerEvents === 'none') continue;
      var r = el.getBoundingClientRect();
      if (r.height > vh * 0.5) continue;
      if (r.bottom >= vh - 2 && r.height >= 40 && r.width > vh * 0.5) return true;
    }
    return false;
  };

  proto.updateSticky = function (bar) {
    var kc = document.querySelector('#kaching-cart');
    var cartOpen = !!(kc && kc.offsetHeight && /open|active|visible/i.test(kc.className + ' ' + (kc.getAttribute('aria-hidden') === 'false' ? 'open' : '')));
    // mobiel: pas zodra de hoofd-CTA boven de viewport is verdwenen; desktop (alleen met stickyDesktop, variant B,
    // voorbeeld sassysaints.com): zodra de hoofd-CTA niet in beeld is (boven of onder de vouw)
    // mobiel: pas na de keuzebox (hoofd-CTA boven de viewport; besluit Thomas 11-09); desktop (stickyDesktop, variant B):
    // zodra de hoofd-CTA niet in beeld is (boven of onder de vouw)
    var desktop = window.innerWidth >= 990;
    // 16-09 (opdracht Thomas): de balk hoort er ook te staan zodra iemand binnenkomt. Mobiel
    // wachtte hij op stickyAtcAbove, dus tot de hoofdknop naar BOVEN uit beeld was; op deze pagina
    // staat die knop ver onder de vouw, waardoor je bovenaan niets kon toevoegen. Nu is de regel
    // voor beide hetzelfde: zichtbaar zolang de hoofdknop niet in beeld is.
    var wanted = desktop ? (!!this.cfg.stickyDesktop && !this.stickyAtcVisible) : !this.stickyAtcVisible;
    var show = wanted && this.stickyNearSection && !cartOpen && this.cfg.mode !== 'prelaunch' && !this.storyOpen && !this.pickerOpen && !this.helpOpen && !this.lenHelpOpen && !this.foreignBottomBar();
    if (show) {
      bar.hidden = false;
      bar.removeAttribute('inert');
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } else {
      bar.classList.remove('is-visible');
      bar.hidden = true;
      bar.setAttribute('inert', '');
    }
    this.liftChat(show ? bar : null);
    this.guardChat(show);
  };

  // Chat-widget vs eigen controls (mobiel): zolang de bubble een deel van .lc__controls (pills, samenvatting, CTA)
  // bedekt en de sticky bar hem niet al omhoog tilt, tijdelijk uitfaden (opacity + pointer-events, blijft in de DOM).
  // Instelling `chat_guard` (config chatGuard) zet dit uit; op desktop (>= 990 px) nooit actief.
  proto.guardChat = function (stickyShown) { // stickyShown: alleen nog informatief
    var chat = document.getElementById('lashthing-chat-frame');
    if (!chat) return;
    var hide = false;
    // ook met zichtbare sticky bar (bubble opgetild) kan hij een accordeon/tab bedekken: dan eveneens vervagen
    if (this.cfg.chatGuard !== false && window.innerWidth < 990) {
      // alleen echte bedienelementen tellen (thumbs, pills, CTA, vergelijk-knop, detail-link), niet het hele tekstblok:
      // zo blijft de bubble zichtbaar zolang er alleen kopjes/hulptekst onder staan
      var c = chat.getBoundingClientRect();
      if (c.width > 0 && c.height > 0) {
        var controls = this.querySelectorAll('label.lc__style, label.lc__pill, [data-atc]:not([data-atc-sticky]), [data-compare-toggle], [data-details], .lc__circle, .lc__usps li, .lc__rating, [data-style-thumb], [data-style-step], [data-gallery-step], [data-tab], .lc__acc-summary, [data-video-play], .lc__video--link, .lc__guarantee-link, [data-scarcity], [data-rating-link], [data-howto-toggle], .lc__video, .lc__howto-media, [data-slot], [data-set-label]');
        for (var i = 0; i < controls.length && !hide; i++) {
          var z = controls[i].getBoundingClientRect();
          if (z.width === 0 || z.height === 0) continue;
          hide = !(c.right <= z.left || c.left >= z.right || c.bottom <= z.top || c.top >= z.bottom);
        }
      }
    }
    if (this.storyOpen || this.helpOpen || this.lenHelpOpen) hide = true; // story-speler, stijlquiz of lengtevenster open: chat vervaagd, ook op desktop
    if (hide === !!this.chatHidden) return;
    this.chatHidden = hide;
    if (!chat.dataset.lcFade) {
      chat.dataset.lcFade = '1';
      chat.style.transition = (chat.style.transition ? chat.style.transition + ', ' : '') + 'opacity var(--duration-short, 150ms) ease';
    }
    chat.style.opacity = hide ? '0' : '';
    chat.style.pointerEvents = hide ? 'none' : '';
    chat.setAttribute('aria-hidden', hide ? 'true' : 'false');
  };

  // Eigen chat-widget (#lashthing-chat-frame, rechtsonder) boven de sticky bar tillen zodat beide bereikbaar blijven.
  proto.liftChat = function (bar) {
    var chat = document.getElementById('lashthing-chat-frame');
    if (!chat) return;
    if (bar) {
      var h = bar.getBoundingClientRect().height || bar.offsetHeight || 0;
      if (!chat.dataset.lcBottom) chat.dataset.lcBottom = chat.style.bottom || '';
      chat.style.transition = chat.style.transition || 'bottom var(--duration-default, 200ms) ease';
      chat.style.bottom = 'calc(' + (chat.dataset.lcBottom || '0px') + ' + ' + Math.round(h + 16) + 'px)';
    } else if (chat.dataset.lcBottom !== undefined) {
      chat.style.bottom = chat.dataset.lcBottom;
    }
  };

  /* ---------- url / live / beacon ---------- */

  proto.syncUrl = function () {
    var self = this;
    clearTimeout(this.urlTimer);
    this.urlTimer = setTimeout(function () {
      var v = self.current();
      if (!v.variantId || !window.history || !window.history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(v.variantId));
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }, URL_DEBOUNCE_MS);
  };

  proto.announce = function (msg) {
    var self = this;
    clearTimeout(this.liveTimer);
    this.liveTimer = setTimeout(function () {
      var el = self.querySelector('[data-live]');
      if (!el) return;
      el.textContent = '';
      el.textContent = msg;
    }, LIVE_DEBOUNCE_MS);
  };

  proto.beacon = function (ev, props) {
    if (!this.cfg.analyticsBeacon) return;
    try {
      var env = 'live';
      if (window.location.search.indexOf('preview_theme_id') !== -1 || (window.Shopify && window.Shopify.designMode)) env = 'preview';
      else if (!/(^|\.)lashthing\.(nl|de|fr)$/.test(window.location.hostname)) env = 'preview';
      var sid = 'anon';
      try {
        sid = window.localStorage.getItem('lt_quiz_sid') || sid;
      } catch (e) {}
      window.fetch('https://timer.lashthing.nl/quiz-api/e', {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sid: sid, env: env, ev: ev, props: props || {} })
      }).catch(function () {});
    } catch (e) {}
  };

  customElements.define('lash-configurator', LashConfigurator);
})();
